﻿import Highcharts from 'highcharts';
import moment from 'moment';
import bootbox from 'bootbox';
require('highcharts/highcharts-more')(Highcharts);
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
require('highcharts/modules/offline-exporting')(Highcharts);
require('highcharts/modules/gantt')(Highcharts);
import { GetCompanyId } from './company';
import { GetEntityId } from './entity';
import { numberFormat, lightenDarkenColor } from '../common/functions';
import { messageDialog } from '../common/dialogs';
import randomColor from 'randomcolor';

// IMPORTANT!
// This code belongs to Simulation Analytics org.nr 991 252 045
// - c/o Frank Isaksen, Laukøyveien 67, 9193 Nikkeby
// - isaksen.frank@gmail.com
// - +47 91885476
// This code is licensed from Simulation Analytics AS to Finansmodell 1 AS
// - The code shall be treated according to the license agreement between Simulation Analytics AS and Finansmodell 1 AS

// IMPORTANT!
// This file may later need to be updated from Simulation Analytics AS
// This is mainly due to that the solutions uses some common solutions such as e.g. the Asset prices database 



// Gets all the chart functions, primarily called from corp.func.general.js (might change)
// Can get color grid from external function.

/*// IMPORTANT! THE ATTACHED JQuery CODE FOR THE CHARTS ARE IN: corp.func.charting.js*/
// That is, the JQuery code that follows the HTML file
// The JQuery code for the online charts are in: chart.js

// Online: chart.js: HomePage\Fehirde.HomePage\Scripts\Corporate\chart.js
// HTML report: corp.func.charting.js: Data\Fehirde.Reporting\Resources\corp.func.charting.js

// Some explanation about how the code for updating charts is working:
// From changing DDLS's on the Analysis output the 'export function UpdateCorporateChart' in 'chart.js'is called
// After 'export function UpdateCorporateChart' code then CoprorateGraphs.cs is called, and then the code 'export function UpdateCorporateChart' in 'chart.js' is called :)
            

export function getCorporateChartFunc(chartDiv, clickCallback, colors, height = 350, width = 700) {
    
    var Divheight = document.getElementById('Graph_Resize').clientHeight;   // Works! 
    if (Divheight != null) {
        if (Divheight > 100) {
            height = Divheight;
        }
    }

    // Idea: Automatically call this code if the User resizes the div?
    // .. https://stackoverflow.com/questions/60436453/how-to-detect-when-the-div-element-width-change-not-window-resize-in-js


    var nHistoric = 13;
     
    if (colors == null || typeof (colors) === 'undefined') {
        colors = [
            '#789cff', // 0: blue
            '#58d058', // 1: green
            '#ff0000', // 2: red
            '#ffa500', // 3: orange
            '#ffff00', // 4: yellow
            '#a020f0', // 5: purple
            '#ffc0cb', // 6: pink
            '#000000', // 7: black      
        ];
    }

    var getFormatter = function (isRating, isPercent, variable, ratingLetters, interval, useSymbols = false) {
        return function () {
            if (this[variable] === 0 && variable === 'y') {
                return undefined;
            }

            if (isPercent) {
                return numberFormat(this[variable], 2, interval, useSymbols) + '%';
            } else if (isRating) {
                //return numberFormat(((this.y) / 20) * 100) + '%';
                return getRatingLetter(ratingLetters, this[variable]); // + (((this.value) / 20) * 100) + '%';
            } else {
                return numberFormat(this[variable], 2, interval, useSymbols);
            }
        };
    };





    // NOTE! The below code is used to set formatting for the charts that are downloaded - DOWNLOADED CHARTS!      DOES NOT SEEM LIKE IT IS WORKING ? ?? 
    //...idea: Possibly different codes for the different charts as e.g.the Development chart is without a title..?
    var chartExportingOptions = {
        enabled: (typeof (document.createElement('a').download) !== 'undefined'),
        chartOptions: { // specific options for the exported image

            

            chart: {
                //spacing: [5, 5, 5, 5] // tighter padding
                spacing: [0, 0, 0, 0] // tighter padding
            },
            title: {
                Style: {
                    fontSize: '10px',
                    fontWeight: 'normal',
                    margin: 0          // The margin below the title.. note the 'title' uses 'margin' VERSUS the 'legend' also uses 'itemMarginTop'
                    
                }
            },


            legend: {
                // PS! 'itemStyle' is is a configuration property within the legend object
                itemStyle: {
                    fontSize: '9px',
                    fontWeight: 'normal'
                },
                itemMarginTop: 0,
                itemMarginBottom: 0,
                margin: 0,              // This controls the space between the outer edge of the legend box and the plot area or axis labels
                padding: 0              // This controls the inner padding of the entire legend box. Setting it to 0 removes all internal padding

            },
            xAxis: {
                labels: {
                    style: {
                        fontSize: '9px'
                    }
                }
            },
            yAxis: {
                labels: {
                    style: {
                        fontSize: '9px'
                    }
                }
            },


            plotOptions: {
                series: {
                    dataLabels: {
                        enabled: false
                    }
                }
            }
        },
        buttons: {
            contextButton: {
                menuItems: [
                    {
                        text: "Print chart", onclick: function () {
                            this.print();
                        }
                    },
                    { separator: true },
                    {
                        text: "Download PNG Image", onclick: function () {
                            this.exportChartLocal();
                        }
                    },
                    {
                        text: "Download JPEG Image", onclick: function () {
                            this.exportChartLocal({ type: 'image/jpeg' });
                        }
                    },
                    {
                        text: "Download SVG Vector Image", onclick: function () {
                            this.exportChartLocal({ type: 'image/svg+xml' });
                        }
                    },
                    { separator: true },
                    {
                        text: "Download CSV", onclick: function () {
                            var csvContent = "data:text/csv;charset=utf-8," + this.getCSV();
                            var encodedUri = encodeURI(csvContent);
                            window.open(encodedUri);
                        }
                    }
                ]
            }
        },
        csv: {
            dateFormat: '%Y-%m-%d'
        },
        scale: 3,
        fallbackToExportServer: false
    };
    var chartLegendOptions = {
        verticalAlign: 'top',
        align: 'center',     // keep it centered (optional, can be 'left')
        y: 0,                // move legend closer to chart (reduce gap)
        itemMarginTop: 0,    // remove extra top gap
        itemMarginBottom: 0, // remove extra bottom gap

        padding: 0,


        symbolPadding: 4,    // space between marker and text
        itemStyle: {
            fontSize: '10px',
            lineHeight: '11px' // tighter line spacing
        }

    };

    var baseVariables = {
        chart: {
            events: { click: function () { clickEvent(baseVariables); } },
            renderTo: chartDiv,
            height: height //ChartHeight
        },
        title: {
            text: null
        },
        credits: {
            enabled: false
        },
        legend: chartLegendOptions,
        exporting: chartExportingOptions,
        plotOptions: {
            series: {
                events: { click: function () { clickEvent(baseVariables); } }
            }
        }
    };



    // Frank FIX! Include this PDF download option! ! Is the code on the Valon Web solution ? ? ?
    function downloadChartPdf(containerId) {
        const chartEl = document.getElementById(containerId);
        if (!chartEl) return;

        // find chart
        const chart = Highcharts.charts.find(
            c => c && c.renderTo.id === containerId
        );

        // hide hamburger menu
        if (chart && chart.exportSVGElements && chart.exportSVGElements[0]) {
            chart.exportSVGElements[0].hide();
        }


        if (chart) {
            chart.reflow();
        }

        const wrapper = document.createElement('div');
        wrapper.style.width = '1120px';
        wrapper.style.margin = '0 auto';
        wrapper.style.padding = '20px';
        wrapper.style.background = '#ffffff';
        wrapper.style.display = 'flex';
        wrapper.style.justifyContent = 'center';

        const clone = chartEl.cloneNode(true);

        // 
        clone.style.margin = '0 auto';
        clone.style.display = 'block';

        wrapper.appendChild(clone);

        html2pdf().from(wrapper).set({
            filename: 'chart.pdf',
            margin: 0,
            html2canvas: {
                scale: 2,
                backgroundColor: '#ffffff'
            },
            jsPDF: {
                unit: 'px',
                format: [1120, 792], // A4 landscape
                orientation: 'landscape'
            }
        }).save().then(() => {
            // 
            if (chart && chart.exportSVGElements && chart.exportSVGElements[0]) {
                chart.exportSVGElements[0].show();
            }
        });
    }


    var transform = function (value, isRating, isPercent) {
        return (isRating ? 20 - value : value) * (isPercent ? 100 : 1)
    };

    var getRatingLetter = function (letters, value) {
        value = 20 - value;
        if (value < 1) value = 1;
        if (value > 20) value = 20;

        return letters[Math.round(value)];
    };

    var getQuarter = function (dateInt) {
        var month = new Date(dateInt).getMonth() + 1;
        return "Q" + (Math.floor(month / 4) + 1);
    };

    var getColor = function (i) {
        if (i < 7 || isNaN(i)) {
            return colors[i];
        }

        var hue;

        switch (i % 7) {
            case 0: hue = 'red'; break;
            case 1: hue = 'orange'; break;
            case 2: hue = 'yellow'; break;
            case 3: hue = 'green'; break;
            case 4: hue = 'blue'; break;
            case 5: hue = 'purple'; break;
            case 6: hue = 'pink'; break;
        }

        return randomColor({ hue: hue });
    };

    var clickEvent = function (chart) {
        if (!chart.blocked && typeof (clickCallback) === 'function') {
            // disabled click on new charts (used for zoomed modals)
            var chartCopy = clone(chart);
            chartCopy.blocked = true;
            chartCopy.exporting.enabled = false;

            clickCallback(chartCopy);
        }
    };

    return {

        // IMPORTANT! CODE BELOW (LINE 2200+, "CheckIfOutputArray") WHICH PROBABLY CALLS THE CORRECT CHARTS, E.G. DEVELOPMENT... 
        // E.g. after the code has been as CorporateGraphs.cs, then goes back to the code below e.g. line 2573'ish where it call these 
        // actual charts e.g. 'development', riskFan'....
        // Important! Below line 2500+ then also reads the chart choices from the DDLS etc.. so if manipulated on CorporateGraphs that must be fixed again ! ! !

        // NB! THE CODE BELOW AT LINE 2200+ IS CALLED BEFORE THE CODE JUST BELOW HERE ! ! ! !

        statements: function (data) {
            var table = $('<table class="table table-striped table-hover table-condensed" />');
            var row;
            var length = data.Data[0].length;
            var nPeriod = data.Periods < length ? data.Periods + 1 : length;
            var nVariables = data.Variables.length;

            // Table header line
            var head = $('<thead />');
            row = $('<tr />');
            row.append($('<th>Dates</th>'));
            for (var i = 1; i < nPeriod; i++) {
                row.append($('<th class="text-right">' + moment(new Date(data.Dates[i])).format('MMM-YY') + (data.Suffixes[i] == null ? "" : data.Suffixes[i]) + '</th>'));
            }
            head.append(row);

            // Table body
            var body = $('<tbody />');

            for (var i = 0; i < nVariables; i++) {
                row = $('<tr />');
                row.append($('<td>' + data.Variables[i] + '</td>'));

                for (var j = 1; j < nPeriod; j++) {
                    row.append($('<td class="text-right">' + numberFormat(data.Data[i][j], 2, null, false) + '</td>'));
                }
                body.append(row);
            }

            table.append(head);
            table.append(body);

            var tableDiv = $('<div id="corporate-MainStatements" />');
            tableDiv.append($('<h5 id="lbl-mainStatementsHeader" style="text-align: center; font-weight: bold; margin-top: 0px; margin-bottom: 10px; padding-top: 10px;">' + data.Title + '</h5>'));
            tableDiv.append(table);

            destroyChart(chartDiv, function () {
                $('#' + chartDiv).html(tableDiv);
            });
        },
        development: function (data, layout) {
            // NB! This 'development' is called from 2 places: 1) 1/2 series or 2) All entities

            // Dual axis: https://www.highcharts.com/demo/combo-dual-axes
            // Multiple axis: https://www.highcharts.com/demo/combo-multi-axes

            // http://dotnet.highcharts.com/

            // Issues wrt Min/Max and interval .... currently the below code is not able to set min value on percentage output to something different from 0...why not?
            // Seems like there is a trade-off/mix between setting min/max, tickInterval and endOnTick
            // https://jsfiddle.net/4wgd5ry4/

            var adjQY = typeof (data.DateAdjInputQOutputY) === 'undefined' ? 0 : data.DateAdjInputQOutputY;

            var isQuarterly = data.periodType === 'Quarterly';
            var devAll = !!data.nEntities;                          // Frank hates this code '!!data.nEntities'...cannot read/understand...and where does 'data.nEntities' come from?
            var nPeriod = data.numPeriods;

            var tooltipDateFormat = 0;      // Default, show the Month and the Year: '%B %Y'
            if (adjQY > 0 || data.periodType == "Yearly") {
                tooltipDateFormat = 1;      // Only show the Year: '%Y'
            }

            //alert(adjQY)
            //alert(data.periodType)
            //alert(tooltipDateFormat)

            if (devAll) {
                nPeriod = data.nPeriod;
            }

            var emptyChart = !devAll && !!(data && data.series1 && data.series1.Name == "" && (!data.series2 || (data.series2 && data.series2.Name == "")));

            var Color0 = parseInt(data.Color1);
            var Color1 = parseInt(data.Color2);
            if (Color0 == null || Color0 == NaN) {
                var Color0 = 0;
            }
            if (Color1 == null || Color1 == NaN) {
                var Color1 = 1;
            }

            // If needs 2 y-axes
            var secondAxis = !devAll && !((data.series1.isPercent && data.series2.isPercent) || (data.series1.isRating && data.series2.isRating)
                || !(data.series1.isPercent || data.series2.isPercent || data.series1.isRating || data.series2.isRating));

            if (!!data.series2 && data.series2.Name != "") secondAxis = secondAxis || data.useSecondYAxis;

            // Only if not dev all 
            //if(!devAll){
            // Check & Set All: data.isRatingAll .... as 'data.isRatingAll' is used to get formatting of the Y-Axis if 2 or more variables            
            if (data.series1.isRating == true && data.series2.isRating == true) {
                data.isRatingAll = true;
            }

            // Check & Set ALL: data.isPercentAll ....below still does not fix the below: formatter: getFormatter(data.isRatingAll, data.isPercentAll, 'value', data.ratingLetters, interval)
            if (data.series1.isPercent == true && data.series2.isPercent == true) {
                data.isPercentAll == true;
            }
            //}          

            // ALLOW THE USER TO SELECT TO USE THE 2'ND Y AXIS .... AND/OR AUTO-SELECT 'secondAxis = true' IF SIGNIFICANT DIFFERENCE IN THEIR MIN/MAX 

            var nAdjustedHistPeriods = data.historicalPeriods > 0 && adjQY <= 0 ? data.historicalPeriods : 0;

            var firstSeries = [];
            var secondSeries = [];
            var differenceSeries = [];
            var covenant = [];
            var interval;

            var type1, type2, type3, showValues = false;
            var showDifference = false;


            switch (layout) {
                case 0: type1 = 'column', type2 = 'column'; break;
                case 1: type1 = 'line', type2 = 'line'; break;
                case 2: type1 = 'column', type2 = 'line'; break;                // Seems like this does not always work wrt showing the line. E.g. sometimes do not show a flat line behind the columns.., shows if an increasing line.. zIndex: (type2 === 'column' && type1 === 'line') ? 1 : null,
                case 3: type1 = 'line', type2 = 'column'; break;
                case 4: type1 = 'column', type2 = 'column', showValues = true; break;
                case 5: type1 = 'line', type2 = 'line', showValues = true; break;

                // Var Charts...these do not work, are not triggered...why not? ....testing to include them on chart.js also
                case 6: type1 = 'column', type2 = 'column', showValues = true; break;
                case 7: type1 = 'column', type2 = 'column', showValues = true; break;
                case 8: type1 = 'column', type2 = 'column', showValues = true; break;
                case 9: type1 = 'column', type2 = 'column', showValues = true; break;
                case 10: type1 = 'column', type2 = 'column', showValues = true; break;

                case 12: type1 = 'column', type2 = 'column', type3 = 'line', showValues = false; break;
                case 13: type1 = 'column', type2 = 'column', type3 = 'line', showValues = true; break;
                case 14: type1 = 'line', type2 = 'line', type3 = 'column', showValues = false; break;
                case 15: type1 = 'line', type2 = 'line', type3 = 'column', showValues = true; break;
            }

            if (layout >= 12 && layout <= 15) showDifference = true;

            var tempDate = 0;
            var tickMonth = 0;
            var ticks = [];

            
            for (var i = 0; i < nPeriod; i++) {
                               

                tempDate = new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY + i]).getTime();

                //alert(tempDate)

                if (isQuarterly) {
                    tickMonth = new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY + i]).getMonth() + 1;
                    if (tickMonth % 6 === 0) {
                        ticks.push(tempDate);
                    }
                }

                if (data.nEntities) { // If AllEntities Dev chart, use only firstSeries for multi-dimensional array
                    for (var j = 0; j < data.nEntities + 1; j++) {

                        if (!firstSeries[j]) {
                            firstSeries[j] = [];
                        }
                        firstSeries[j][i] = [tempDate, transform(data.chart[j][i], data.isRatingAll, data.isPercentAll)];
                    }
                } else {
                    firstSeries.push([tempDate, transform(data.chart[0][i], data.series1.isRating, data.series1.isPercent)]);
                    secondSeries.push([tempDate, transform(data.chart[1][i], data.series2.isRating, data.series2.isPercent)]);
                    if (data.CovenantIncluded && (nHistoric - nAdjustedHistPeriods + adjQY + i) >= nHistoric) {
                        covenant.push([tempDate, transform(data.chart[2][i])]);
                    }
                    if (showDifference &&
                        !data.series1.isRating && !data.series2.isRating &&
                        ((data.series1.isPercent && data.series2.isPercent) || (!data.series1.isPercent && !data.series2.isPercent))) {

                        differenceSeries.push([tempDate, firstSeries[i][1] - secondSeries[i][1]]);          // The best generic alternative
                        // differenceSeries.push([tempDate, secondSeries[i][1] - firstSeries[i][1]]);      // A possible alternatvie if comparing Comparison calculations?
                        // PS! Could possibly use alternative 2 if the User has selected to output the same variable?
                    } else {
                        showDifference = false;
                    }

                }
            }

            var series = [];

            // ### Find max/min - for interval ###
            var max = data.chart[0][0];
            var min = data.chart[0][0];

            var max2ndYAxis = data.chart[1][0];
            var min2ndYAxis = data.chart[1][0];
            var interval2ndYAxis = 0;

            // Alt. A) 1 or 2 ENTITIES
            // Put 1-3 inside the below check? ...do not think it is necessary
            //if(!devAll){            
            //}
            // 1) 0'th series 
            for (var j = 0; j < nPeriod; j++) {
                var value = data.chart[0][j];
                if (data.series1.isPercent) value *= 100;

                if (value > max) {
                    max = value;
                }
                if (value < min) {
                    min = value;
                }
            }
            // 2) possible 1'st series...do not include check of the possible 1'st series if that is on the 2'nd y-axis
            if (!!data.series2 && data.series2.Name != "" && secondAxis == false) {
                for (var j = 0; j < nPeriod; j++) {
                    var value = data.chart[1][j];
                    if (data.series2.isPercent) value *= 100;

                    if (value > max) {
                        max = value;
                    }
                    if (value < min) {
                        min = value;
                    }
                }
            }
            // 3) Possible covenant/target
            if (data.CovenantIncluded) {
                for (var j = 0; j < nPeriod; j++) {
                    if (data.chart[2][j] != 0) {
                        if (data.chart[2][j] > max) {
                            max = data.chart[2][j];
                        }
                        if (data.chart[2][j] < min) {
                            min = data.chart[2][j];
                        }
                    }
                }
            }

            // 4) Comparison
            if (showDifference) {
                for (var j = 0; j < nPeriod; j++) {
                    if (differenceSeries[j][1] > max) {
                        max = differenceSeries[j][1];
                    }
                    if (differenceSeries[j][1] < min) {
                        min = differenceSeries[j][1];
                    }
                }
            }

            // Alt. B) ALL ENTITIES ..... 4) All entities...if called from CorporateGraphs.cs where gets the deveelopment forall the entities...not just 1 or 2..
            if (devAll) {
                for (var i = 1; i < data.nEntities + 1; i++) {
                    for (var j = 0; j < nPeriod; j++) {
                        if (data.chart[i][j] > max) {
                            max = data.chart[i][j];
                        }
                        if (data.chart[i][j] < min) {
                            min = data.chart[i][j];
                        }
                    }
                }
            }

            // Issues wrt Rating on the Y Axis as we then we show text from a list of strings, and error occurs sometimes when no difference in rating
            // The issue is solved by setting 'min' as undefined in those cases and the Highchart code magically (:)) fixes the Y Axis
            // https://github.com/highcharts/highcharts/issues/6682
            var TestIfRatingConst = 0;                       // Seems like YAxis does not work if constant rating
            var TestIfRatingConst2 = 0;

            // 5) Min Max and Interval       ....PS! Further down in the code then set max to undefined if not rating?      
            if (data.series1.isRating) {

                if (max == min) {
                    TestIfRatingConst = 1;                  // // Seems like YAxis does not work if constant rating...in this case set the 'min' to undefined further below
                }

                max = Math.ceil(max);       // Round up, 1 integer
                min = Math.floor(min) -5;      // Round down 1 integer?

                //min = min - 2;
                //max = max + 2;

                TestIfRatingConst = 1;      // set to '=1' ... Test to see if get full scale always

                if ((max - min) <= 4) {
                    min = min - 1;
                    max = max + 1;

                    //TestIfRatingConst = 1;                  // Seems like rating y-axis does not work if small change
                }

                //min = 0;        // Testing to see if I get the y-axis to always start at the bottom (cc)...seems like it is working

                if (min <= 0) {
                    min = 0;
                    max = max + 1;
                }
            }
            else {
                //max = max * 1.01;  
                //min = min -(max*0.01);          // To get the same abs diff.?
                if (min > 0) {
                    min = min * 0.99;
                }
                else {
                    min = min * 1.01;
                }

                if (Math.abs(max) > 1 || Math.abs(min) > 1) {
                    // alt. a) Big numbers                    
                    max = Math.ceil(max * 100) / 100;       // Round up, 2 decimals
                    min = Math.floor(min * 100) / 100;      // Round down 2 decimals
                }
                else {
                    // alt. b) Small numbers
                    max = Math.ceil(max * 10000) / 10000;       // Round up, 4 decimals  
                    min = Math.floor(min * 10000) / 10000;      // Round down 4 decimals
                }
            }
            // 'interval' is used in :  var getFormatter...but we do not set it in the var chartData           
            //interval = Math.floor(((max - min)/5)*1000000)/1000000;               // Round down 6 decimals...?
            interval = Math.abs(max - min);

            if (TestIfRatingConst == 1) {
                min = undefined;                 // // Seems like YAxis does not work if constant rating...in this case set the 'min' to undefined further below
            }

            // 6) Possible 2'nd YAxis
            if (secondAxis) {
                for (var j = 0; j < nPeriod; j++) {
                    if (data.chart[1][j] > max2ndYAxis) {
                        max2ndYAxis = data.chart[1][j];
                    }
                    if (data.chart[1][j] < min2ndYAxis) {
                        min2ndYAxis = data.chart[1][j];
                    }
                }
            }
            else {
                max2ndYAxis = max;
                min2ndYAxis = min;
            }

            // 7) Min Max and Interval  
            if (data.series2.isRating) {

                if (max2ndYAxis == min2ndYAxis) {
                    TestIfRatingConst2 = 1;                  // // Seems like YAxis does not work if constant rating
                }

                max2ndYAxis = Math.ceil(max2ndYAxis);       // Round up, 1 integer
                min2ndYAxis = Math.floor(min2ndYAxis);      // Round down 1 integer?
                min2ndYAxis = min2ndYAxis - 2;
                max2ndYAxis = max2ndYAxis + 2;
                if ((max2ndYAxis - min2ndYAxis) <= 4) {
                    min2ndYAxis = min2ndYAxis - 1;
                    max2ndYAxis = max2ndYAxis + 1;
                }
                if (min2ndYAxis <= 0) {
                    min2ndYAxis = 0;
                    max2ndYAxis = max2ndYAxis + 1;
                }
            }
            else {
                if (min2ndYAxis > 0) {
                    min2ndYAxis = min2ndYAxis * 0.99;
                }
                else {
                    min2ndYAxis = min2ndYAxis * 1.01;
                }

                if (Math.abs(max2ndYAxis) > 1 || Math.abs(min2ndYAxis) > 1) {
                    // alt. a) Big numbers
                    max2ndYAxis = Math.ceil(max2ndYAxis * 100) / 100;       // Round up, 2 decimals  
                    min2ndYAxis = Math.floor(min2ndYAxis * 100) / 100;      // Round down 2 decimals
                }
                else {
                    // alt. b) Small numbers
                    max2ndYAxis = Math.ceil(max2ndYAxis * 10000) / 10000;       // Round up, 4 decimals
                    min2ndYAxis = Math.floor(min2ndYAxis * 10000) / 10000;      // Round down 4 decimals
                }
            }
            interval2ndYAxis = Math.abs(max2ndYAxis - min2ndYAxis);    // Do not know how it affects the axis by e.g. dividing by 5...?

            if (TestIfRatingConst2 == 1) {
                min2ndYAxis = undefined;            // // Seems like YAxis does not work if constant rating...set to undefined and the Highchart code fixes the axis
            }


            // If only 1 series/output chosen - Then show that selected output's name as Graphname instead of as series name?
            // Note! Further below the OLD series 1 name is set: name: data.series1.Name
            // OR set the Legend size higher? 
            var TitleName = null;
            
            if (data.Series2Name == "") {
                //TitleName = data.name;
                //series1Name = " ";          // Does it work to not show the Series1Name as a series label?
                
            }
            else {
                TitleName = data.name;
                
            }

            if (devAll) {
                // a) All!....versus alt b) 1 or 2 variables
                var currentColor = getColor(0);

                series[0] = {
                    name: data.entityNames[0],
                    data: firstSeries[0],
                    type: type1,
                    dataLabels: {
                        formatter: getFormatter(data.isRatingAll, data.isPercentAll, 'y', data.ratingLetters, interval),
                        enabled: showValues
                    },
                    marker: { enabled: false },
                    color: currentColor
                };
                for (var i = 1; i < data.nEntities + 1; i++) {

                    var currentColor = getColor(i);
                    series[i] = {
                        name: data.entityNames[i],
                        data: firstSeries[i],
                        type: type1,
                        color: currentColor,
                        dataLabels: {
                            formatter: getFormatter(data.isRatingAll, data.isPercentAll, 'y', data.ratingLetters, interval),
                            enabled: showValues
                        },
                        type: type2,
                        marker: { enabled: false },
                        color: currentColor
                    };
                }
                interval = Math.abs(max - min);
            }
            else {
                // b) 1 or 2 variables

                var ChartColor0 = getColor(0);       // Default: blue
                var ChartColor1 = getColor(1);       // Default: green
                if (Color0 != 0) {
                    ChartColor0 = getColor(Color0);
                }
                if (Color1 != 1) {
                    ChartColor1 = getColor(Color1);
                }

                // 1'st series
                if (!emptyChart) {
                    series.push({
                        name: data.series1.Name,
                        //name: series1Name,            // Does not work..
                        type: type1,
                        data: firstSeries,
                        fillOpacity: 0.1,
                        marker: { enabled: false },
                        zIndex: (type1 === 'line') ? 2 : 0,
                        dataLabels: {
                            formatter: getFormatter(data.series1.isRating, data.series1.isPercent, 'y', data.ratingLetters, interval),
                            enabled: showValues
                        },
                        color: Highcharts.Color(ChartColor0).setOpacity(0.7).get('rgba'),
                        zoneAxis: 'x',
                        zones: [
                            {
                                value: data.historicalPeriods > 0 ? firstSeries[data.historicalPeriods][0] : null,
                                color: Highcharts.Color(ChartColor0).brighten(-0.2).setOpacity(1).get('rgba')
                            },
                            {
                                dashStyle: "shortDash",
                                color: Highcharts.Color(ChartColor0).setOpacity(1).get('rgba')
                            }
                        ]
                    });
                }

                // 2'nd series ... if relevant ...if data.series2.Name != ""
                if (!!data.series2 && data.series2.Name != "") {
                    series.push({
                        name: secondAxis ? data.series2.Name + " (2'nd axis)" : data.series2.Name,
                        type: type2,
                        data: secondSeries,
                        fillOpacity: 0.1,
                        marker: { enabled: false },
                        yAxis: secondAxis ? 1 : 0,      // interpretation: if secondAxis==true then put on the 2'nd y axis which is "1" the firts is "0".."2" is the 2'nd 2'nd y axis (that is, even to the right of the 2'nd y -axis)
                        zIndex: (type2 === 'line') ? 2 : 0,
                        dataLabels: {
                            formatter: getFormatter(data.series2.isRating, data.series2.isPercent, 'y', data.ratingLetters, interval2ndYAxis),
                            enabled: showValues
                        },
                        color: Highcharts.Color(ChartColor1).setOpacity(0.7).get('rgba'),
                        zoneAxis: 'x',
                        zones: [
                            {
                                value: data.historicalPeriods > 0 ? secondSeries[data.historicalPeriods][0] : null,
                                color: Highcharts.Color(ChartColor1).brighten(-0.2).setOpacity(1).get('rgba')
                            },
                            {
                                dashStyle: "shortDash",
                                color: Highcharts.Color(ChartColor1).setOpacity(1).get('rgba')
                            }
                        ]
                    });     // End: eries.push({
                }   // End 2'nd series

                // 3'rd series ... if relevant
                if (data.CovenantIncluded) {

                    series.push({
                        name: "Target",
                        type: 'line',
                        lineWidth: 1,
                        data: covenant,
                        marker: { enabled: false },
                        color: getColor(2),
                        dataLabels: {
                            formatter: getFormatter(false, false, 'y', null, interval),
                            enabled: showValues
                        }
                    });
                }   // end 3'rd series

                if (showDifference && Array.isArray(differenceSeries) && differenceSeries.length > 0) {
                    series.push({
                        name: 'Difference',
                        type: type3,
                        color: getColor(3),
                        data: differenceSeries,
                        dataLabels: {
                            formatter: getFormatter(false, data.series1.isPercent, 'y', null, interval),
                            enabled: showValues
                        }
                    });
                }
            }

            

            var chartData = {
                chart: {
                    events: {
                        load: function () {
                            if (emptyChart) {

                                this.renderer.text('NO DATA', 400, 270)
                                    .css({
                                        color: '#1010114d',
                                        fontSize: '64px'
                                    })
                                    .add();
                            }
                        }
                    }
                },               


                title: {
                    // text: null,
                    useHTML: true,
                    text: TitleName
                },

                xAxis: {
                    tickPositioner: isQuarterly ? function () {
                        var returnTicks = ticks;

                        returnTicks.info = {
                            unitName: "month", //unitName: "day",
                            higherRanks: {} // Omitting this would break things
                        };
                        return returnTicks;
                    } : undefined,
                    dateFormat: '%B %Y',
                    type: 'datetime'
                },

                yAxis: !secondAxis ? {

                    // Alt. 1) If only uses the first y-axis....if DevAll or just 1 variable...formatting, e.g.: data.isRatingAll  .... All                   

                    title: {
                        text: null
                        //useHTML: true,
                        //text: TitleName
                    },
                    opposite: false,
                    labels: {
                        formatter: getFormatter(data.series1.isRating, data.series1.isPercent, 'value', data.ratingLetters, interval)
                    },
                    min: min           //  YAxis does not work if constant rating....above set min to undefined if constant rating                    

                } : [{

                    // Alt. 2, a) If uses both y-axis, this is the 1'st y-axis .... formatting e.g.: data.series1.isRating .... nr. 1

                    title: {
                        text: null
                        //useHTML: true,
                        //text: TitleName
                    },
                    opposite: false,
                    labels: {
                        formatter: getFormatter(data.series1.isRating, data.series1.isPercent, 'value', data.ratingLetters, interval)
                    },
                    min: min

                }, {

                    // Alt. 2, b) If uses both y-axis, this is the 2'nd y-axis .... formatting e.g.: data.series2.isRating .... nr. 2

                    title: {
                        text: null
                        //useHTML: true,
                        //text: TitleName

                    },
                    opposite: true,
                    labels: {
                        formatter: getFormatter(data.series2.isRating, data.series2.isPercent, 'value', data.ratingLetters, interval2ndYAxis)
                    },
                    min: min2ndYAxis

                }],

                plotOptions: {
                    column: {
                        groupPadding: devAll ? 0.2 : 0,
                        softThreshold: false,
                        shadow: true,
                        pointPadding: 0.05,
                        borderWidth: 0
                    },
                    line: {
                    }
                },

                tooltip: {
                    crosshairs: true,
                    shared: true,
                    useHTML: true,
                    formatter: function () {
                        // OLD: var s = (isQuarterly ? '(' + getQuarter(this.x) + ') ' : '') + Highcharts.dateFormat(adjQY > 0 ? '%Y' : '%B %Y', this.x, true); // '%B %Y' - means show month and year
                        var s = (isQuarterly ? '(' + getQuarter(this.x) + ') ' : '') + Highcharts.dateFormat(tooltipDateFormat > 0 ? '%Y' : '%B %Y', this.x, true);
                        

                        $.each(this.points, function (i, point) {
                            var isPercent = devAll ? data.isPercentAll : ((i === 0 && data.series1.isPercent) || (i === 1 && data.series2.isPercent));
                            var isRating = devAll ? data.isRatingAll : ((i === 0 && data.series1.isRating) || (i === 1 && data.series2.isRating));

                            s += '<br/><span style="color:' + point.series.color + '">\u25CF</span><span>' + point.series.name + ': ';
                            +(isPercent ? '%' : '') + '</span>';

                            if (isPercent) {
                                s += numberFormat(point.y, 2, interval, false) + "%";
                            } else if (isRating) {
                                s += '<b>' + getRatingLetter(data.ratingLetters, point.y) + '</b> (' + numberFormat(((point.y) / 20) * 100, interval, false) + '%)';
                                s = s;
                            } else {
                                s += numberFormat(point.y, 2, interval, false);
                            }
                        });

                        s += '<br/><br/>';

                        
                        s += 'Changes:';

                        $.each(this.points, function (i, point) {
                            if (point && point.point && point.point.index == 0) return;

                            var isRating = devAll ? data.isRatingAll : ((i === 0 && data.series1.isRating) || (i === 1 && data.series2.isRating));

                            s += '<br/><span style="color:' + point.series.color + '">\u25CF</span><span>' + point.series.name;

                            var pointIndex = point.point.index;
                            var currentValue = point.y;
                            var prevValue = point && point.series && point.series.data && point.series.data[pointIndex - 1] ? point.series.data[pointIndex - 1].y : 0;
                            var diff = currentValue - prevValue;

                            
                            var percentageDiff = ((currentValue / prevValue) - 1) * 100;
                            if (isNaN(percentageDiff) || percentageDiff == Infinity || percentageDiff == -Infinity) percentageDiff = 0;

                            if (!isRating) {
                                s += ': </span>' + numberFormat(diff, 2, interval, false) + '  :  ' + numberFormat(percentageDiff, 2, interval, false) + '%';
                            } else if (isRating) {
                                s += ': -';
                            }
                        });
                        return s;
                    }
                },
                series: series
            };

            destroyChart(chartDiv, function (chartObj) {
                chartObj = new Highcharts.Chart($.extend(true, baseVariables, chartData));

            });
        },
        riskFan: function (data) {
            var adjQY = typeof (data.DateAdjInputQOutputY) === 'undefined' ? 0 : data.DateAdjInputQOutputY;
            var isQuarterly = data.PeriodName === 'Quarterly';


            var tooltipDateFormat = 0;          // Show Month and Year
            if (adjQY > 0 || data.PeriodName == "Yearly") {
                tooltipDateFormat = 1;          // Only show year
            }

            var FanChartSettings = data.FanChartSettings;
            

            // I hate the below code line ! ! ! it is impossible to keep control over the logic!  Always split the code into simpler understandable parts!
            var nAdjustedHistPeriods = data.nHistPeriod > 0 && adjQY <= 0 ? data.nHistPeriod : 0;


            var history = [];
            //var historyAdjust = data.nHistPeriod > 0 && adjQY <= 0 ? 1 : 0;
            var historyAdjust = 1;
            nHistoric = 13;      // Set at the very top of this code: nHistoric = 13....cannot change at the top as the Development chart (and possibly others) are using it

            var forecast = [];
            var range1 = [];
            var range2 = [];
            var range3 = [];
            var covenant = [];
            var ComparisonCaseArrayOne = [];
            var ComparisonCaseArrayTwo = [];
            var ComparisonCaseArrayThree = [];
            var count = 0;
            var interval = 0;
            
            
            // 2 alternative fan chart data input: 1) Normal, 2) Adjusted historical dates (e.g. if Q in and Y out)
            if(adjQY == 0)
            {
                // 1) Normal 
                while (count < nAdjustedHistPeriods) {
                    //while (count < data.nHistPeriod) {                
                    history[count] = [new Date(data.dates[nHistoric - nAdjustedHistPeriods + count]).getTime(), transform(data.riskfan[count][7], data.isRating, data.isPercent)];
                    count++;
                }  

                if (count == 0) count++;
            
                var ComparisonCase = data.ComparisonCaseIncluded;   

                
                for (var i = count; i <= data.numPeriods; i++) {
                
                    // Changed 'data.nHistPeriod' with 'nAdjustedHistPeriods' as on the Dev chart..to get it correct when Q input and Y output

                    forecast[i - count] = [new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY + i - historyAdjust]).getTime(), transform(data.riskfan[i - historyAdjust][3], data.isRating, data.isPercent)];
                    range1[i - count] = [new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY + i - historyAdjust]).getTime(), transform(data.riskfan[i - historyAdjust][2], data.isRating, data.isPercent), transform(data.riskfan[i - historyAdjust][4], data.isRating, data.isPercent)];
                    range2[i - count] = [new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY + i - historyAdjust]).getTime(), transform(data.riskfan[i - historyAdjust][1], data.isRating, data.isPercent), transform(data.riskfan[i - historyAdjust][5], data.isRating, data.isPercent)];
                    range3[i - count] = [new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY + i - historyAdjust]).getTime(), transform(data.riskfan[i - historyAdjust][0], data.isRating, data.isPercent), transform(data.riskfan[i - historyAdjust][6], data.isRating, data.isPercent)];
                
                    if (data.CovenantIncluded && (nAdjustedHistPeriods == 0 || i > count)) {
                        covenant.push([new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY + i - historyAdjust]).getTime(), transform(data.riskfan[i - historyAdjust][8])]);
                    }

                    if(ComparisonCase>0 && (nAdjustedHistPeriods == 0 || i > count)){
                        ComparisonCaseArrayOne.push([new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY + i - historyAdjust]).getTime(), transform(data.riskfan[i - historyAdjust][9], data.isRating, data.isPercent)]);
                        ComparisonCaseArrayTwo.push([new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY + i - historyAdjust]).getTime(), transform(data.riskfan[i - historyAdjust][10], data.isRating, data.isPercent)]);
                        ComparisonCaseArrayThree.push([new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY + i - historyAdjust]).getTime(), transform(data.riskfan[i - historyAdjust][11], data.isRating, data.isPercent)]);
                    }

                    if (interval < Math.abs(data.riskfan[i - historyAdjust][0] - data.riskfan[i - historyAdjust][6])) {
                        interval = Math.abs(data.riskfan[i - historyAdjust][0] - data.riskfan[i - historyAdjust][6]);
                    }
                }

            }
            else{
                
                // 2) Adjusted historical dates...e.g. Q input and yearly output
                //while (count < nAdjustedHistPeriods) {
                while (count < data.nHistPeriod) {                
                    history[count] = [new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY+ count]).getTime(), transform(data.riskfan[count][7], data.isRating, data.isPercent)];
                    count++;
                }  

                if (count == 0) count++;
            
                var ComparisonCase = data.ComparisonCaseIncluded;   

                //alert(count)

                for (var i = count; i <= data.numPeriods; i++) {                
                    // Changed 'data.nHistPeriod' with 'nAdjustedHistPeriods' as on the Dev chart..to get it correct when Q input and Y output

                    forecast[i - count] = [new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY + i - historyAdjust]).getTime(), transform(data.riskfan[i - historyAdjust][3], data.isRating, data.isPercent)];
                    range1[i - count] = [new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY + i - historyAdjust]).getTime(), transform(data.riskfan[i - historyAdjust][2], data.isRating, data.isPercent), transform(data.riskfan[i - historyAdjust][4], data.isRating, data.isPercent)];
                    range2[i - count] = [new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY + i - historyAdjust]).getTime(), transform(data.riskfan[i - historyAdjust][1], data.isRating, data.isPercent), transform(data.riskfan[i - historyAdjust][5], data.isRating, data.isPercent)];
                    range3[i - count] = [new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY + i - historyAdjust]).getTime(), transform(data.riskfan[i - historyAdjust][0], data.isRating, data.isPercent), transform(data.riskfan[i - historyAdjust][6], data.isRating, data.isPercent)];
                
                    if (data.CovenantIncluded && (nAdjustedHistPeriods == 0 || i > count)) {
                        covenant.push([new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY + i - historyAdjust]).getTime(), transform(data.riskfan[i - historyAdjust][8])]);
                    }

                    if(ComparisonCase>0 && (nAdjustedHistPeriods == 0 || i > count)){
                        ComparisonCaseArrayOne.push([new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY + i - historyAdjust]).getTime(), transform(data.riskfan[i - historyAdjust][9], data.isRating, data.isPercent)]);
                        ComparisonCaseArrayTwo.push([new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY + i - historyAdjust]).getTime(), transform(data.riskfan[i - historyAdjust][10], data.isRating, data.isPercent)]);
                        ComparisonCaseArrayThree.push([new Date(data.dates[nHistoric - nAdjustedHistPeriods + adjQY + i - historyAdjust]).getTime(), transform(data.riskfan[i - historyAdjust][11], data.isRating, data.isPercent)]);
                    }

                    if (interval < Math.abs(data.riskfan[i - historyAdjust][0] - data.riskfan[i - historyAdjust][6])) {
                        interval = Math.abs(data.riskfan[i - historyAdjust][0] - data.riskfan[i - historyAdjust][6]);
                    }

                }

            }

            // Shorten label names if necessary
            var HistoricLabel = "History";
            var ForecastLabel = "Forecast";

            var ConfidenceIntervalInner = "75%";        // Default
            var ConfidenceIntervalMedium = "90%";
            var ConfidenceIntervalOuter = "95%";

            if (FanChartSettings == 1) {
                ConfidenceIntervalInner = "50%";
            }
            if (FanChartSettings == 2) {
                ConfidenceIntervalInner = "50%";
                ConfidenceIntervalMedium = "75%";
                ConfidenceIntervalOuter = "90%";
            }
            if (FanChartSettings == 3) {
                ConfidenceIntervalInner = "50%";
                ConfidenceIntervalMedium = "75%";
                ConfidenceIntervalOuter = "95%";
            }

            var series = [{
                name: HistoricLabel,
                data: history,
                custom: {
                    group: 1
                },
                marker: { enabled: false },
                includeInCSVExport: false,
                zIndex: 3,
                color: 'black'
            }, {
                name: ForecastLabel,
                data: forecast,
                custom: {
                    group: 1
                },
                marker: { enabled: false },
                zIndex: 3,
                dashStyle: 'ShortDash',
                color: 'black'
            }, {
                name: ConfidenceIntervalInner, // '75%',
                data: range1,
                custom: {
                    group: 2
                },
                marker: { enabled: false },
                type: 'arearange',
                lineWidth: 0,
                linkedTo: ':previous',
                color: getColor(0),
                showInLegend: true,
                //fillOpacity: 0.6,
                zIndex: 2
            }, {
                name: ConfidenceIntervalMedium,     //'90%',
                data: range2,
                custom: {
                    group: 2
                },
                marker: { enabled: false },
                type: 'arearange',
                lineWidth: 0,
                linkedTo: ':previous',
                color: lightenDarkenColor(getColor(0), 30),
                //fillOpacity: 0.4,
                showInLegend: true,
                zIndex: 1
            }, {
                name: ConfidenceIntervalOuter,  // '95%',
                data: range3,
                custom: {
                    group: 2
                },
                marker: { enabled: false },
                type: 'arearange',
                lineWidth: 0,
                linkedTo: ':previous',
                color: lightenDarkenColor(getColor(0), 60),
                showInLegend: true,
                //fillOpacity: 0.3,
                zIndex: 0
            }];

            if (data.CovenantIncluded) {
                series.push({
                    name: "Target",
                    type: 'line',
                    custom: {
                        group: 3
                    },
                    lineWidth: 1, // lineWidth: 2?
                    zIndex: 4,
                    data: covenant,
                    marker: { enabled: false },
                    color: getColor(2),
                    dataLabels: {
                        formatter: getFormatter(false, false, 'y', null, interval)
                    }
                });
            }

            if (ComparisonCase > 0) {
                series.push({
                    // name: "Comp.High",
                    //name: "Comparison (95%) high",
                    name: "High",
                    type: 'line',
                    custom: {
                        group: 4
                    },
                    lineWidth: 1,
                    zIndex: 4,
                    data: ComparisonCaseArrayThree,
                    marker: { enabled: false },
                    dashStyle: 'LongDash',
                    color: 'grey',
                    dataLabels: {
                        formatter: getFormatter(false, false, 'y', null, interval)
                    }
                });

                series.push({
                    name: "Median",
                    type: 'line',
                    custom: {
                        group: 4
                    },
                    lineWidth: 1,
                    zIndex: 4,
                    data: ComparisonCaseArrayTwo,
                    marker: { enabled: false },
                    linkedTo: ':previous',
                    showInLegend: true,
                    dashStyle: 'LongDash',
                    color: 'grey',
                    dataLabels: {
                        formatter: getFormatter(false, false, 'y', null, interval)
                    }
                });

                series.push({
                    name: "Low",
                    type: 'line',
                    custom: {
                        group: 4
                    },
                    lineWidth: 1, 
                    zIndex: 4,
                    data: ComparisonCaseArrayOne,
                    marker: { enabled: false },
                    linkedTo: ':previous',
                    showInLegend: true,
                    dashStyle: 'LongDash',
                    color: 'grey',
                    dataLabels: {
                        formatter: getFormatter(false, false, 'y', null, interval)
                    }
                });
            }


            var titleHTML = data.GraphName;
            if (data.Subtitle && data.Subtitle.length > 0) {
                titleHTML += '<span style="font-size: 12px; margin-top: 0px; margin-bottom: 0px; padding-top: 0px; padding-bottom: 0px;">' + data.Subtitle + '</span>'; 
                // PS! The data.Subtitle can be e.g. '(Comparison case: Derivatives NOT included )'
            }

            var chartData = {
                title: {
                    useHTML: true,
                    text: titleHTML
                },
                xAxis: {
                    type: 'datetime'
                },
                yAxis: {
                    //type: 'logarithmic',
                    title: {
                        text: null
                    },
                    labels: {
                        formatter: getFormatter(data.isRating, data.isPercent, 'value', data.ratingLetters, interval)
                    }
                },
                tooltip: {
                    useHTML: true,
                    //xDateFormat: adjQY > 0 ? "%Y" : "%B %Y",
                    formatter: function () {
                        //var s = (isQuarterly ? '(' + getQuarter(this.x) + ') ' : '') + Highcharts.dateFormat(adjQY > 0 ? '%Y' : '%B %Y', this.x, true);
                        var s = (isQuarterly ? '(' + getQuarter(this.x) + ') ' : '') + Highcharts.dateFormat(tooltipDateFormat > 0 ? '%Y' : '%B %Y', this.x, true);

                        var pointsArray = this.points;
                        $.each(pointsArray, function (i, point) {
                            var isPercent = data.isPercent;
                            var isRating = data.isRating;

                            if (i > 0) {
                                var previousPointGroup = 0;
                                var currentPointGroup = 0;
                                try {
                                    previousPointGroup = pointsArray[i - 1].series.options.custom.group;
                                    currentPointGroup = point.series.options.custom.group;
                                } catch (e) {
                                    console.error(e);
                                }
                                if (previousPointGroup !== currentPointGroup) {
                                    s += '<br>';
                                }
                            }

                            s += '<br><span style="color:' + point.series.color + '">\u25CF</span><span>' + point.series.name + ': </span>';

                            s += '<b>';

                            if (point.point.high == null) {
                                if (isPercent) {
                                    s += numberFormat(point.y, 2, interval, false) + "%";
                                } else if (isRating) {
                                    s += '<b>' + getRatingLetter(data.ratingLetters, point.y) + '</b>';
                                } else {
                                    s += numberFormat(point.y, 2, interval, false);
                                }
                            } else {
                                if (isPercent) {
                                    s += numberFormat(point.point.low, 2, interval, false) + "% - " + numberFormat(point.point.high, 2, interval, false) + "%";
                                } else if (isRating) {
                                    s += getRatingLetter(data.ratingLetters, point.point.low) + ' - ' + getRatingLetter(data.ratingLetters, point.point.high);
                                } else {
                                    s += numberFormat(point.point.low, 2, interval, false) + ' - ' + numberFormat(point.point.high, 2, interval, false);
                                }
                            }
                            s += '</b>';
                        });

                        return s;
                    },
                    crosshairs: true,
                    shared: true//,
                    //valueDecimals: 1
                },
                series: series
            };

            destroyChart(chartDiv, function (chartObj) {
                chartObj = new Highcharts.Chart($.extend(true, baseVariables, chartData));
            });
        },
        distribution: function (data, layout) {
            var values = [];


            //var TargetValueBase = data.distributionfan[2][0];           // In case just 1 target line, using plot line
            var SimCaseValue = data.distributionfan[2][1];              // Calc Sim Case valuation
            var DiffPercentValue = data.distributionfan[2][2];          // Deviation between Valuation sim case and TargetValueBase

            var len = data.distributionfan[0].length;

            var showValues = false;
            var accumulatedValues = false;
            var accumulatedSum = 0;

            var maxYvalue = 0;

            for (var i = 0; i < len; i++) {
                accumulatedSum += (data.distributionfan[1][i] * 100);
                values[i] = {
                    x: transform(data.distributionfan[0][data.isRating ? len - i - 1 : i], data.isRating, data.isPercent),
                    y: data.distributionfan[1][data.isRating ? len - i - 1 : i] * 100, accumulated: accumulatedSum
                };
                if (values[i].y > maxYvalue) {
                    maxYvalue = values[i].y;
                }
            }        
            

            switch (layout) {
                case 1: showValues = true; break;
                case 2: showValues = true; accumulatedValues = true; break;
            }

            var xStart = values[0].x;
            var interval = values[1].x - xStart;
            var exp = -2;

            // Find interval exponent
            for (var i = -12; i < 1000000; i++) {
                if (interval > Math.pow(10, -i)) {
                    exp = -(i + 2);
                    break;
                }
            }


            var minX = xStart;
            var dataMin = xStart;
            
            if (data.ValuationTarget > 0 && data.ValuationTarget < minX) {
                minX = data.ValuationTarget;
            }
            if (data.ShowSharePrice && data.SharePrice > 0 && data.SharePrice < minX) {
                minX = data.SharePrice;
            }
            var maxX = values[len - 1].x;
            var dataMax = maxX;
            if (data.ValuationTarget > maxX) {
                maxX = data.ValuationTarget;
            }
            if (data.ShowSharePrice && data.SharePrice > maxX) {
                maxX = data.SharePrice;
            }
            xStart = minX;
            interval = (dataMax - dataMin) / 9;

            // Declare as the below in order to include more thant 1 series.. if possible 2 series e.g.include target

            var MedianCalculatedValue = data.MedianCalculatedValue;

            
            var ValuationRangeText = "Range: " + numberFormat(dataMin, 2, null, false) + " to " + numberFormat(dataMax + interval, 2, null, false);
            if (MedianCalculatedValue != 0) {
                ValuationRangeText = ValuationRangeText + " ( Median : " + numberFormat(MedianCalculatedValue, 2, null, false) + ")";
            }


            var series = [{
                id: 'main-data',

                //name: 'Valuation range',
                name: ValuationRangeText,

                type: 'column',
                fillOpacity: 0.1,
                showInLegend: true,
                color: {
                    linearGradient: { x1: 0, x2: 1, y1: 0, y2: 1 },
                    stops: [
                        [0, 'rgba(70, 106, 205, 0.7)'],
                        [1, 'rgba(170, 206, 255, 0.7)']
                    ]
                },
                data: values,
                dataLabels: {
                    formatter: function () {
                        var returnVal;
                        if (accumulatedValues) {
                            returnVal = this.point.accumulated;
                        } else {
                            returnVal = this.y;
                        }
                        var s = numberFormat(returnVal, 2, interval) + '%';
                        return s;
                    },
                    enabled: showValues
                }
            }];


            // Show price change from SharePrice to ValuationTarget
            var PriceChangeSharePriceToTarget = 0;
            var PriceChangeSharePriceToValuationHigh = 0;
            var PriceChangeSharePriceToValuationMedian = 0;
            var PriceChangeSharePriceToValuationLow = 0;
           
            if (data.ShowValuationTarget && data.ShowSharePrice) {
                PriceChangeSharePriceToTarget = ((data.ValuationTarget / data.SharePrice) - 1) * 100;                               
            }

            if (data.ShowSharePrice) {
                var AddedToHighValue = data.distributionfan[0][9] - data.distributionfan[0][8];
                    PriceChangeSharePriceToValuationHigh = (((data.distributionfan[0][9] + AddedToHighValue) / data.SharePrice) - 1) * 100;
                PriceChangeSharePriceToValuationMedian = ((data.MedianCalculatedValue / data.SharePrice) - 1) * 100;
                PriceChangeSharePriceToValuationLow = ((data.distributionfan[0][0] / data.SharePrice) - 1) * 100;
            }


            if (data.ShowValuationTarget) {
                var ValuationTargetLineData = [[data.ValuationTarget, 0], [data.ValuationTarget, maxYvalue]];

                var ValuationTargetText = "Target: " + numberFormat(data.ValuationTarget, 2, null, false);

                series.push({
                    id: 'valuation-target-line',

                    //name: 'Valuation target',
                    name: ValuationTargetText,

                    type: 'line',
                    data: ValuationTargetLineData,
                    color: 'black',
                    dashStyle: 'shortdash',
                    marker: {
                        enabled: false
                    }
                });
            }

            if (data.ShowSharePrice) {
                var SharePriceLineData = [[data.SharePrice, 0], [data.SharePrice, maxYvalue]];

                var SharePriceText = "Share price: " + numberFormat(data.SharePrice, 2, null, false);

                series.push({
                    id: 'share-price-line',

                    //name: 'Share price',
                    name: SharePriceText,

                    type: 'line',
                    data: SharePriceLineData,
                    color: 'green',
                    marker: {
                        enabled: true
                    }
                });
            }

            var additionalDistributionTitle = " (" + numberFormat(dataMin, 2, null, false) + " to " + numberFormat(dataMax+interval, 2, null, false) + ")";

            //var Layout = data.chart.Layout;
            var ProbabilityText = "Probability: ";
            if (layout == 2) {
                ProbabilityText = "Accumulated probability from the left: ";
            }


            var chartData = {
                title: {
                    //text: data.GraphName + data.DistPeriodName + additionalDistributionTitle
                    text: data.GraphName + data.DistPeriodName 
                },
                xAxis: {
                    startOnTick: true,
                    endOnTick: true,
                    showFirstLabel: false,
                    labels: {
                        formatter: getFormatter(data.isRating, data.isPercent, 'value', data.RatingLetters, interval, false)
                    }                      
                },
                yAxis: {
                    labels: {
                        format: "{value}%"
                    },
                    title: {
                        text: null
                    },
                },
                tooltip: {
                    useHTML: true,
                    formatter: function () {
                        var seriesId = this.series && this.series.options && this.series.options.id ? this.series.options.id : "";
                        if (seriesId === "share-price-line") {

                            //return "Share price " + this.x;

                            if (PriceChangeSharePriceToValuationHigh == 0 && PriceChangeSharePriceToValuationMedian == 0 && PriceChangeSharePriceToValuationLow == 0) {
                                return "<strong>Share price : " + + this.x + '</strong>';
                            }
                            else {    
                                 
                                // return "<strong>Share price : " + + this.x + '</strong>' + '<br/><br> Price change to reach the Calculated median valuation: ' + numberFormat(PriceChangeSharePriceToValuationOne, 2, interval, false) + '%';                                

                                var s = "<strong>Share price : " + + this.x + '</strong>';

                                

                                s += '<br/><br><strong> Price change needed to reach respectively: </strong>';

                                if (PriceChangeSharePriceToTarget != 0) {
                                    s += '<br/> Target: ' + numberFormat(PriceChangeSharePriceToTarget, 2, interval, false) + '%';
                                }

                                s += '<br/> High valuation: ' + numberFormat(PriceChangeSharePriceToValuationHigh, 2, interval, false) + ' %';                                
                                s += '<br/> Median valuation: ' + numberFormat(PriceChangeSharePriceToValuationMedian, 2, interval, false) + '%';  
                                s += '<br/> Low valuation: ' + numberFormat(PriceChangeSharePriceToValuationLow, 2, interval, false) + '%';  


                                return s;

                            }


                        } else if (seriesId === "valuation-target-line") {
                            //return "Valuation target " + this.x;

                            if (PriceChangeSharePriceToTarget == 0) {

                                return "<strong>Target : " + this.x + '</strong>';
                            }
                            else {
                                return "<strong>Target : " + this.x + '</strong>' + '<br/>><br> Price change needed to reach this Target: ' + numberFormat(PriceChangeSharePriceToTarget, 2, interval, false) + '%';
                            }


                        } else if (seriesId === "main-data") {
                            // var s = '<b>' + numberFormat(accumulatedValues ? this.point.accumulated : this.y, 1, interval, false) + '%</b>';

                            
                            var s = '<br/><strong>From: </strong>';
                            // s += '<br/>Value from: ';

                            if (data.isPercent) {
                                s += numberFormat(this.x, 2, interval, false) + "%";
                            } else if (data.isRating) {
                                s += '<b>' + getRatingLetter(data.RatingLetters, this.x) + '</b> (' + numberFormat(((this.x) / 20) * 100, 2, interval, false) + '%)';
                                s = s;
                            } else {
                                s += numberFormat(this.x, 2, interval, false);
                            }

                            s += '<br/><strong>To: </strong>';
                            if (data.isPercent) {
                                s += numberFormat(this.x + interval, 2, interval, false) + "%";
                            } else if (data.isRating) {
                                s += '<b>' + getRatingLetter(data.RatingLetters, this.x + interval) + '</b> (' + numberFormat(((this.x + interval) / 20) * 100, 2, interval, false) + '%)';
                                s = s;
                            } else {
                                s += numberFormat(this.x + interval, 2, interval, false);
                            }

                            if (layout > 0) {
                                s += '<br/><br/><strong>' + ProbabilityText + '</strong>'+ numberFormat(accumulatedValues ? this.point.accumulated : this.y, 1, interval, false) + '%</b>';
                            }

                            
                            // var s = '<b>' + numberFormat(accumulatedValues ? this.point.accumulated : this.y, 1, interval, false) + '%</b>';

                            return s;
                        }
                        
                    },

                    valueSuffix: "%"
                },
                plotOptions: {
                    column: {
                        pointPlacement: "between",
                        groupPadding: 0,
                        pointPadding: 0,
                        borderWidth: 0,
                        shadow: true
                    }
                },
                series: series
            };

            destroyChart(chartDiv, function (chartObj) {
                chartObj = new Highcharts.Chart($.extend(true, baseVariables, chartData));
            });
        },
        valuation: function (data) {
            var series1 = [];
            var series2 = [];

            // Original
            //var numValues = data.Layout < 2 ? 4 : 5;
            //var categories = data.Layout < 2 ? ['Forecast', '+ Terminal', '- Debt', '= Total'] : ['WACC -2%', 'WACC -1%', 'WACC unchanged', 'WACC +1%', 'WACC +2%'];
            var showValues = data.Layout % 2 === 1;

            var numValues = data.Layout < 2 ? 4 : 5;
            var categories = data.Layout < 2 ? ['Forecast/explicit', '+ Terminal value', '+ Debt/adj.', '= Total value'] : ['WACC -2%', 'WACC -1%', 'WACC unchanged', 'WACC +1%', 'WACC +2%'];

            var max = data.marketvaluechart[0][0];
            var min = data.marketvaluechart[0][0];

            for (var i = 0; i < numValues; i++) {
                series1[i] = data.marketvaluechart[0][i];
                series2[i] = data.marketvaluechart[1][i];

                // Only get interval (max/min) from series 1?
                if (series1[i] > max) {
                    max = series1[i];
                }
                if (series1[i] < min) {
                    min = series1[i];
                }
            }

            var interval = Math.abs(max - min);

            var series = [];

            // var ValuationCalculatedText = data.Series1Name + ". Value:  " + numberFormat(data.marketvaluechart[0][3], 2, null, false);
            var ValuationCalculatedText = data.Series1Name;

            // if 2 valuations output, then want to have the Calculated value in the legend name (as it is now not in the graph header
            if (data.Series2Name != "") {
                ValuationCalculatedText = ValuationCalculatedText + ". Total: " + numberFormat(data.marketvaluechart[0][3], 2, null, false);
            }

            var valuationSeries1Id = 'valuation-series-1';
            var valuationSeries2Id = 'valuation-series-2';
            var valuationTargetLineId = 'valuation-target-line';
            var sharePriceLineId = 'sharePriceLineId';

            series.push({
                id: valuationSeries1Id,
                type: 'column',
                name: ValuationCalculatedText,
                //fillOpacity: 0.1,
                //color: {
                //    linearGradient: { x1: 0, x2: 1, y1: 0, y2: 1 },
                //    stops: [
                //        [0, lightenDarkenColor(getColor(0), -50)],
                //        [1, lightenDarkenColor(getColor(0), 50)]
                //    ]
                //},
                fillOpacity: 0.1,
                color: {
                    linearGradient: { x1: 0, x2: 1, y1: 0, y2: 1 },
                    stops: [
                        [0, 'rgba(70, 106, 205, 0.7)'],
                        [1, 'rgba(170, 206, 255, 0.7)']
                    ]
                },
                dataLabels: {
                    formatter: getFormatter(null, null, 'y', null, interval),
                    enabled: showValues
                },
                data: series1
            });

            if (data.Series2Name != "") {

                var ValuationCalculatedText2 = data.Series2Name + ". Total: " + numberFormat(data.marketvaluechart[1][3], 2, null, false);

                series.push({
                    type: 'column',
                    id: valuationSeries2Id,
                    name: ValuationCalculatedText2,
                    fillOpacity: 0.1,
                    color: {
                        linearGradient: { x1: 0, x2: 1, y1: 0, y2: 1 },
                        stops: [
                            [0, lightenDarkenColor(getColor(1), -50)],
                            [1, lightenDarkenColor(getColor(1), 50)]
                        ]
                    },
                    dataLabels: {
                        formatter: getFormatter(null, null, 'y', null, interval),
                        enabled: showValues
                    },
                    data: series2
                });
            }

            // Show price change from SharePrice to ValuationTarget
             var PriceChangeValuationTwoToSharePrice = 0; 


            // Valuation columns % of Total valuation.... how to differentiate between the possible 2 series.. ? ? ? ? ....maybe not important to include?
            var ExplicitValueOfTotal = 0;
            var ImplicitValueOfTotal = 0;
            var DebdtAdjValueOfTotal = 0;





            if (data.ShowValuationTarget) {

                var ValuationTargetLineData = [numValues];
                for (var i = 0; i < numValues; i++) {
                    ValuationTargetLineData[i] = data.ValuationTarget;
                }

                var ValuationTargetText = "Target: " + numberFormat(data.ValuationTarget, 2, null, false);

                series.push({
                    name: ValuationTargetText,
                    id: valuationTargetLineId,
                    type: 'line',
                    data: ValuationTargetLineData,
                    color: 'black',
                    dashStyle: 'shortdash',
                    marker: {
                        enabled: false
                    }
                });
            }

            if (data.ShowSharePrice) {
                var SharePriceLineData = [numValues];
                for (var i = 0; i < numValues; i++) {
                    SharePriceLineData[i] = data.SharePrice;
                }

                var SharePriceText = "Share price: " + numberFormat(data.SharePrice, 2, null, false);

                series.push({
                    name: SharePriceText,
                    id: sharePriceLineId,
                    type: 'line',
                    data: SharePriceLineData,
                    color: 'green',
                    marker: {
                        enabled: true
                    }
                });
            }

            var chartData = {
                title: {
                    text: data.GraphName
                },
                xAxis: {
                    categories: categories
                },
                yAxis: {
                    title: {
                        text: null
                    },
                    labels: {
                        formatter: function () {
                            return numberFormat(this.value, 2, null, false);
                        }
                    }
                },
                plotOptions: {
                    column: {
                        groupPadding: 0,
                        pointPadding: 0.05,
                        borderWidth: 0,
                        shadow: true
                    }
                },
                tooltip: {
                    useHTML: true,
                    formatter: function () {
                        var seriesId = this.series && this.series.options && this.series.options.id ? this.series.options.id : "";

                        var showPriceChangeNeeded = data.Layout < 2 && this.point.index === 3 || data.Layout >= 2;

                        switch (seriesId) {
                            case valuationSeries1Id:
                            case valuationSeries2Id:
                                var s = this.x + '<br/><span style="color:' + this.series.color + '">\u25CF</span><span>' + this.series.name + ': <strong>' + numberFormat(this.y, 2, interval, false) + '</strong></span>';

                                if (data.ShowSharePrice && showPriceChangeNeeded) {
                                    var diffToReachValue = ((this.y / data.SharePrice) - 1) * 100;
                                    s += '<br/><br/>';
                                    s += 'Price change needed for share to reach the value: <strong>' + numberFormat(diffToReachValue, 2, interval, false) + ' %</strong>';
                                }
                                return s;

                            case sharePriceLineId:
                                var s = "<strong>Share price : " + data.SharePrice + '</strong>';
                                return s;

                            case valuationTargetLineId:
                                var s = "<strong>Target : " + data.ValuationTarget + '</strong>';

                                if (data.ShowSharePrice) {
                                    var diffToReachValue = ((data.ValuationTarget / data.SharePrice) - 1) * 100;
                                    s += '<br/><br/>';
                                    s += 'Price change needed for share to reach the valuation target: <strong>' + numberFormat(diffToReachValue, 2, interval, false) + ' %</strong>';
                                }

                                return s;
                        }
                    },
                    valueSuffix: "%"
                },
                series: series
            };

            destroyChart(chartDiv, function (chartObj) {
                chartObj = new Highcharts.Chart($.extend(true, baseVariables, chartData));
            });
        },
        footballFieldValuation: function (data) {
            var series = [];
            var categories = [];

            var OutputType = data.OutputType;

            var getNextColorsForRange = function (rangeIndex) {
                if (Highcharts && Highcharts.Color && Highcharts.getOptions) {
                    var colors = Highcharts.getOptions().colors;
                    var colorIndex = rangeIndex % colors.length;

                    var color = colors[colorIndex];
                    var darkerColor = Highcharts.Color(color).brighten(-0.3).setOpacity(1).get('rgba');// Highcharts.Color(color).brighten(-0.3).get('rgb');
                    var brighterColor = Highcharts.Color(color).brighten(0.3).setOpacity(0.2).get('rgba'); // Highcharts.Color(color).brighten(0.3).get('rgb');

                    return {
                        peakColor: darkerColor,
                        outerColor: brighterColor
                    }
                }
                return {
                    peakColor: '#0000',
                    outerColor: '#ffff'
                }
            }


            // Each Valuation output
            for (var i = 0; i < data.SeriesData.length; i++) {

                var minValue = data.SeriesData[i][0];
                var maxValue = data.SeriesData[i][1];
                var medianValue = data.Median[i];

                var seriesData = {
                    type: 'columnrange',
                    name: data.MethodLabels[i],
                    id: i + 1,
                    data: [[i, minValue, maxValue]]
                };

                if (OutputType != 0 && (maxValue != minValue)) {
                    // Range estimate

                    var cY = (maxValue - medianValue) / (maxValue - minValue);

                    var colorsForRange = getNextColorsForRange(i);

                    seriesData.color = {
                        linearGradient: { x1: 0.5, y1: 0, x2: 0.5, y2: 1 },
                        stops: [
                            [0, colorsForRange.outerColor],
                            [cY, colorsForRange.peakColor],
                            [1, colorsForRange.outerColor]
                        ]
                    }

                }

                series.push(seriesData);

                categories.push('');
            }           

            var PriceChangeSharePriceToTarget = 0;
            if (data.ShowValuationTarget && data.ValuationTarget > 0 && data.ShowSharePrice && data.SharePrice > 0) {
                PriceChangeSharePriceToTarget = ((data.ValuationTarget / data.SharePrice) - 1) * 100;
            }


            var valuationTargetLineId = 'valuation-target-line';
            var sharePriceLineId = 'sharePriceLineId';

            if (data.ShowValuationTarget && data.ValuationTarget > 0) {
                var dataPoints = [];
                for (var i = 0; i < data.SeriesData.length; i++) {
                    dataPoints.push(data.ValuationTarget);
                }
                series.push({
                    type: 'line',
                    id: valuationTargetLineId,
                    name: 'Target',
                    color: 'black',
                    dashStyle: 'shortdash',
                    lineWidth: 3,
                    marker: {
                        enabled: false
                    },
                    data: dataPoints
                });
            }

            if (data.ShowSharePrice && data.SharePrice > 0) {
                var dataPoints = [];
                for (var i = 0; i < data.SeriesData.length; i++) {
                    dataPoints.push(data.SharePrice);
                }
                series.push({
                    type: 'line',
                    id: sharePriceLineId,
                    name: 'Share price',
                    color: 'green',
                    lineWidth: 3,
                    marker: {
                        enabled: true
                    },
                    data: dataPoints
                });
            }

            var chartData = {
                chart: {
                    inverted: true
                },
                title: {
                    text: data.Series1Name
                },
                yAxis: {
                    title: {
                        text: null
                    },
                    annotations: {
                        labelOptions: {
                            formatter: function () {
                                return numberFormat(this.value, 2, null, false);
                            }
                        }
                    },
                },
                xAxis: {
                    categories: categories
                },
                plotOptions: {
                    columnrange: {
                        shadow: true,
                        borderWidth: 0.1,
                        borderColor: 'gray',
                        grouping: false,
                        pointPadding: -0.15
                    }
                },
                tooltip: {
                    useHTML: true,
                    formatter: function () {
                        var seriesId = this.series && this.series.options && this.series.options.id ? this.series.options.id : "";
                        if (seriesId === valuationTargetLineId) {
                            if (PriceChangeSharePriceToTarget == 0) {
                                return "<strong>Target: " + data.ValuationTarget + "</strong>";
                            }
                            else {
                                return "<strong>Target: " + data.ValuationTarget + '</strong>' + '<br/><br> Price change needed to reach this Target: ' + numberFormat(PriceChangeSharePriceToTarget, 2) + '%';
                            }

                        } else if (seriesId === sharePriceLineId) {
                            return "<strong>Share price : " + data.SharePrice + "</strong>";
                        } else {
                            // if (OutputType == 0) {
                            if (OutputType == 0 || (this.point.options.low / this.point.options.high)>0.97) {
                                // A) Point estimate
                                var s = "Valuation method: <strong>" + this.point.series.name + "</strong><br/>Value: <strong> " + numberFormat((this.point.options.low + this.point.options.high) / 2, 2, null, false) +'</strong>';

                                var NrId = seriesId;
                                var Median = data.Median[NrId - 1]; 

                                var PriceToHigh = 0;
                                var PriceToMedian = 0;
                                var PriceToLow = 0;

                                if (data.SharePrice > 0) {
                                    PriceToHigh = numberFormat(((this.point.options.high / data.SharePrice) - 1) * 100, 2, null, false);
                                    PriceToMedian = numberFormat(((Median / data.SharePrice) - 1) * 100, 2, null, false);
                                    PriceToLow = numberFormat(((this.point.options.low / data.SharePrice) - 1) * 100, 2, null, false);
                                } 

                                if (data.ShowSharePrice && data.SharePrice > 0) {
                                    s += '<br>';
                                    s += "<br/>Price change needed to reach this value: <strong>" + PriceToMedian + " % </strong>";
                                    //s += "High: " + PriceToHigh + "%<br/>";
                                    //s += PriceToMedian + "%<br/>";
                                    //s += "Low: " + PriceToLow + "%";
                                }

                                return s;
                            }
                            else {
                                // B) Range estimate
                                //return "Valuation method: <strong>" + this.point.series.name + "</strong><br/>Value from: <strong>" + numberFormat(this.point.options.low, 2, null, false) + " </strong> To: <strong> " + numberFormat(this.point.options.high, 2, null, false) + '</strong>';

                                var NrId = seriesId;
                                var Median = data.Median[NrId-1];                                

                                var PriceToHigh = 0;
                                var PriceToMedian = 0;
                                var PriceToLow = 0;
                                
                                if (data.SharePrice > 0) {
                                    PriceToHigh = numberFormat(((this.point.options.high / data.SharePrice) - 1) * 100, 2, null, false);
                                    PriceToMedian = numberFormat(((Median / data.SharePrice) - 1) * 100, 2, null, false);
                                    PriceToLow = numberFormat(((this.point.options.low / data.SharePrice) - 1) * 100, 2, null, false);
                                } 
                                //return "Valuation method: <strong>" + this.point.series.name + "</strong><br/>Value from: <strong>" + numberFormat(this.point.options.low, 2, null, false) + " </strong> To: <strong> " + numberFormat(this.point.options.high, 2, null, false) + '</strong>' + " <br/>Median value: <strong> " + numberFormat(Median, 2, null, false) + '</strong>';
                                var s = "Valuation method: <strong>" + this.point.series.name + "</strong><br/>Value from: <strong>" + numberFormat(this.point.options.low, 2, null, false) + " </strong> To: <strong> " + numberFormat(this.point.options.high, 2, null, false) + '</strong>' + " <br/>Median value: <strong> " + numberFormat(Median, 2, null, false) + "</strong>" ;
                                                               
                                if (data.ShowSharePrice && data.SharePrice > 0) {
                                    s += '<br>';
                                    s += "<br/><strong>Price change needed to reach respectively: </strong>" + "<br/>";
                                    s += "High: " + PriceToHigh + "%<br/>";
                                    s += "Median: " + PriceToMedian + "%<br/>";
                                    s += "Low: " + PriceToLow + "%";
                                }
                                

                                return s;

                            }
                        }
                    }
                },
                series: series
            };
            destroyChart(chartDiv, function (chartObj) {
                chartObj = new Highcharts.Chart($.extend(true, baseVariables, chartData));
            });
        },
        valPerEntity: function (data) {
            var series1 = [];
            var series2 = [];
            var showValues = data.Layout % 2 === 1;
            var len = data.EntityNames.length - 1;

            for (var i = 0; i < len; i++) {
                var currentFirstColor = getColor(i);
                var currentSecondColor = lightenDarkenColor(currentFirstColor, -30);
                series1[i] = {
                    y: data.ValuationPerEntity[0][i], color: {
                        linearGradient: { x1: 0, x2: 1, y1: 0, y2: 1 },
                        stops: [
                            [0, lightenDarkenColor(currentFirstColor, -50)],
                            [1, lightenDarkenColor(currentFirstColor, 50)]
                        ]
                    }
                };
                series2[i] = {
                    y: data.ValuationPerEntity[1][i], color: {
                        linearGradient: { x1: 0, x2: 1, y1: 0, y2: 1 },
                        stops: [
                            [0, lightenDarkenColor(currentSecondColor, -50)],
                            [1, lightenDarkenColor(currentSecondColor, 50)]
                        ]
                    }
                };
            }

            var series = [];
            series[0] = {
                name: data.Series1Name,
                fillOpacity: 0.1,
                dataLabels: {
                    format: "{point.y:,.0f}",
                    enabled: showValues
                },
                data: series1
            };

            if (data.Series2Name != "") {
                series[1] = {
                    name: data.Series2Name,
                    fillOpacity: 0.1,
                    dataLabels: {
                        format: "{point.y:,.0f}",
                        enabled: showValues
                    },
                    data: series2
                };
            }

            var chartData = {
                chart: {
                    //height: 350,
                    type: 'column'
                },
                title: {
                    text: data.GraphName
                },
                xAxis: {
                    categories: data.EntityNames
                },
                yAxis: {
                    title: {
                        text: null
                    },
                    labels: {
                        formatter: function () {
                            return numberFormat(this.value, 2, null, false);
                        }
                    }
                },
                legend: {
                    enabled: (data.Series2Name != "")
                },
                tooltip: {
                    crosshairs: true,
                    shared: true,
                    valueDecimals: 2
                },
                plotOptions: {
                    column: {
                        groupPadding: 0,
                        pointPadding: 0.05,
                        borderWidth: 0
                    }
                },
                series: series
            };

            destroyChart(chartDiv, function (chartObj) {
                chartObj = new Highcharts.Chart($.extend(true, baseVariables, chartData));
            });
        },
        fxExposureDev: function (data, layout) {
            var adjQY = typeof (data.DateAdjInputQOutputY) === 'undefined' ? 0 : data.DateAdjInputQOutputY;

            var nPeriods = data.numPeriods;
            var nFx = data.nFX + 1; // Include "Total [basefx]"
            var seriesData = [];
            var series = [];
            var showValues = data.Layout % 2 === 1;

            // FXNames[0] -> Data[nFx-1]
            // FXNames[1] -> Data[0]
            // ...
            // FXNames[nFx - 1] -> Data[nFx - 2]

            for (var fx = 0; fx < nFx; fx++) {
                var temp = (fx == 0) ? nFx - 1 : fx - 1;
                seriesData[fx] = [];
                for (var i = 0; i < nPeriods; i++) {
                    //seriesData[fx][i] = [new Date(data.dates[nHistoric + i]).getTime(), data.FXExposureDevelopmentArray[temp][i + 1]];
                    seriesData[fx][i] = [new Date(data.dates[nHistoric + i + adjQY]).getTime(), data.FXExposureDevelopmentArray[temp][i + 1]];
                    //seriesData[fx][i] = [parseInt(data.dates[nHistoric + i + adjQY].substring(6)), data.FXExposureDevelopmentArray[i + 1 + (temp * (nPeriods + 1))]];
                }
            }

            series[0] = {
                name: data.FXNames[0],
                data: seriesData[0],
                color: {
                    linearGradient: { x1: 0, x2: 1, y1: 0, y2: 1 },
                    stops: [
                        [0, lightenDarkenColor(getColor(0), -50)],
                        [1, lightenDarkenColor(getColor(0), 50)]
                    ]
                },
                type: 'column',
                dataLabels: {
                    format: "{point.y:,.0f}",
                    enabled: showValues
                }
            };

            for (var fx = 1; fx < nFx; fx++) {
                series[fx] = {
                    name: data.FXNames[fx],
                    color: getColor(fx),
                    data: seriesData[fx],
                    type: 'line',
                    dataLabels: {
                        format: "{point.y:,.0f}",
                        enabled: showValues
                    }
                };
            }

            var chartData = {
                chart: {
                    //height: 350,
                    type: 'column'
                },
                title: {
                    text: data.GraphName
                },
                xAxis: {
                    type: 'datetime'
                },
                yAxis: {
                    title: {
                        text: null
                    },
                    labels: {
                        formatter: function () {
                            return numberFormat(this.value, 2, null, false);
                        }
                    }
                },
                plotOptions: {
                    column: {
                        //pointPlacement: "between",
                        groupPadding: 0,
                        //threshold: null,
                        shadow: true,
                        pointPadding: 0.05,
                        borderWidth: 0
                    }
                },
                tooltip: {
                    xDateFormat: "%B %Y",
                    crosshairs: true,
                    shared: true,
                    valueDecimals: 1
                },
                series: series
            };

            destroyChart(chartDiv, function (chartObj) {
                chartObj = new Highcharts.Chart($.extend(true, baseVariables, chartData));
            });
        },
        fxExposureVar: function (data, layout) {
            var exposure = [];
            var riskVar = [];
            var riskIndividual = [];
            var fxNames = [];
            var len = data.FXNames.length

            var interval = Math.max.apply(Math, data.FXVaR);
            if (isNaN(interval) || interval == null) {
                interval = data.MaxValue;                                       // Is this correct?
            }

            var showValues = data.Layout % 2 === 1;

            for (var i = 0; i < len - 1; i++) {
                exposure[i] = data.FXVaROutput[i];
                riskVar[i] = data.riskVar[i];
                riskIndividual[i] = data.riskIndividual[i];
                fxNames[i] = data.FXNames[i + 1];
            }

            fxNames[len - 2] += " (total)";

            var chartData = {
                chart: {
                    //height: 350,
                    type: 'column'
                },
                title: {
                    text: data.GraphName
                },
                xAxis: {
                    categories: fxNames
                },
                yAxis: {
                    title: {
                        text: null
                    },
                    labels: {
                        formatter: function () {
                            return numberFormat(this.value, 2, null, false);
                        }
                    }
                },
                plotOptions: {
                    column: {
                        groupPadding: 0,
                        pointPadding: 0.05,
                        borderWidth: 0
                    }
                },
                tooltip: {
                    formatter: function () {
                        var s = this.x;

                        s += '<br/><span style="color:' + this.series.color + '">\u25CF</span><span>' + this.series.name + ': ' + numberFormat(this.y, 2, interval, false) + '</span>';
                        return s;
                    }
                },
                series: [{
                    name: data.Series1Name,
                    fillOpacity: 0.1,
                    color: getColor(0),
                    dataLabels: {
                        formatter: getFormatter(false, false, 'y', null, interval),
                        enabled: showValues
                    },
                    data: exposure
                }, {
                    name: data.Series2Name,
                    fillOpacity: 0.1,
                    color: getColor(1),
                    dataLabels: {
                        formatter: getFormatter(false, false, 'y', null, interval),
                        enabled: showValues
                    },
                    data: riskVar
                }, {
                    name: data.Series3Name,
                    fillOpacity: 0.1,
                    color: getColor(2),
                    dataLabels: {
                        formatter: getFormatter(false, false, 'y', null, interval),
                        enabled: showValues
                    },
                    data: riskIndividual
                }]
            };

            destroyChart(chartDiv, function (chartObj) {
                chartObj = new Highcharts.Chart($.extend(true, baseVariables, chartData));
            });
        },
        waterfall: function (data, layout) {
            
            // NB! If update the code, then make sure to update the code on corp.func.charting.js also (the JQuery code for the HTML report)

            var showValues = data.Layout % 2 === 1;

            if (data.entityNames == undefined || data.entityNames != null) {
                var nEntities = data.EntityNamesforChart.length;
                var series = [];
                var seriesData1 = [];
                var seriesData2 = [];

                //alert(nEntities)

                for (var i = 1; i < nEntities; i++) {
                    var temp = i == nEntities - 1 ? 0 : i;
                    var currentFirstColor = getColor(temp);
                    var currentSecondColor = lightenDarkenColor(currentFirstColor, -10);
                    seriesData2[i - 1] = { y: 0 };
                    seriesData1[i - 1] = {
                        name: data.EntityNamesforChart[i], y: data.WaterfallChartArray[i][0], color: {
                            linearGradient: { x1: 0, x2: 1, y1: 0, y2: 1 },
                            stops: [
                                [0, lightenDarkenColor(currentFirstColor, -50)],
                                [1, lightenDarkenColor(currentFirstColor, 50)]
                            ]
                        }
                    };
                }

                seriesData1[nEntities - 1] = { name: 'Total', isSum: true };
                seriesData2[nEntities - 1] = { y: 0 };

                // PS! Include the diversification column??? as on the PDF report?

                seriesData2[nEntities] = {
                    name: 'Consolidated', y: data.WaterfallChartArray[0][0], color: {
                        linearGradient: { x1: 0, x2: 1, y1: 0, y2: 1 },
                        stops: [
                            [0, lightenDarkenColor(currentSecondColor, -50)],
                            [1, lightenDarkenColor(currentSecondColor, 50)]
                        ]
                    }
                };

                var chartData = {
                    chart: {
                        //height: 350,
                        type: 'waterfall'
                    },
                    legend: {
                        enabled: false
                    },
                    title: {
                        text: data.GraphName
                    },
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: null
                        },
                        labels: {
                            formatter: function () {
                                return numberFormat(this.value, 2, null, false);
                            }
                        }
                    },
                    tooltip: {
                        xDateFormat: "%B %Y",
                        crosshairs: true,
                        useHTML: true,
                        shared: true,
                        formatter: function () {
                            var s = '';

                            $.each(this.points, function (i, point) {
                                //var isPercent = devAll ? data.isPercentAll : ((i === 0 && data.series1.isPercent) || (i === 1 && data.series2.isPercent));
                                //var isRating = devAll ? data.isRatingAll : ((i === 0 && data.series1.isRating) || (i === 1 && data.series2.isRating));
                                var isPercent = false;
                                var isRating = false;

                                if (i == 1 && point.y == 0) {
                                    return;
                                }

                                s += point.point.name;

                                s += '<br/><span style="color:' + point.series.color + '">\u25CF</span>';

                                if (isPercent) {
                                    s += '<b>' + numberFormat(point.y, 2, null, false) + '%</b>';
                                } else if (isRating) {
                                    s += '<b>' + getRatingLetter(data.ratingLetters, point.y) + '</b> (' + numberFormat(((point.y) / 20) * 100, null, false) + '%)';
                                    s = s;
                                } else {
                                    s += '<b>' + numberFormat(point.y, 2, null, false) + '</b>';
                                }
                            });

                            return s;
                        },
                        valueDecimals: 1
                    },
                    series: [{
                        data: seriesData1,
                        dataLabels: {
                            format: "{point.y:,.0f}",
                            verticalAlign: 'top',
                            enabled: showValues
                        }
                    }, {
                        type: 'column',
                        data: seriesData2,
                        dataLabels: {
                            format: "{point.y:,.0f}",
                            //verticalAlign: 'top',
                            verticalAlign: 'top'
                            //enabled: showValues       // Removed this as it wrongly showed 0 values...
                        }
                    }]
                };

                destroyChart(chartDiv, function (chartObj) {
                    chartObj = new Highcharts.Chart($.extend(true, baseVariables, chartData));
                });
            }
        },
        customUserDataDevelopment: function (plainData, layout) {
            var xAxisName = plainData && plainData.xAxisName ? plainData.xAxisName : '';
            var yAxisName = plainData && plainData.yAxisName ? plainData.yAxisName : '';

            var data = null;
            try {
                data = JSON.parse(plainData.seriesData);
            } catch (e) {
                data = null;
            }

            var series = [];
            var labels = [];
            var seriesType = "column";
            var emptyChart = false;
            var errorText = 'NO DATA';
            var dashedLine = false;
            var stacking = null;
            var inverted = null;
            var showLineMarkers = false;
            var showValues = plainData.showValues;
            var showChangesInTooltip = plainData.showChangesInTooltip;

            var PIE_TYPE = 11;
            var WATERFALL_TYPE = 15;
            var VERTICAL_COLUMN_RANGE_TYPE = 3;
            var HORIZONTAL_COLUMN_RANGE_TYPE = 4;

            switch (layout) {
                case 0: seriesType = 'column'; break;
                case 1: seriesType = 'column', stacking = "normal"; break;
                case 2: seriesType = 'column', stacking = "percent"; break;
                case VERTICAL_COLUMN_RANGE_TYPE: seriesType = 'columnrange'; break;
                case HORIZONTAL_COLUMN_RANGE_TYPE: seriesType = 'columnrange', inverted = true; break;
                case 5: seriesType = 'bar'; break;
                case 6: seriesType = 'bar', stacking = "normal"; break;
                case 7: seriesType = 'bar', stacking = "percent"; break;
                case 8: seriesType = 'line'; break;
                case 9: seriesType = 'line', showLineMarkers = true; break;
                case 10: seriesType = 'line', dashedLine = true; break;
                case PIE_TYPE: seriesType = 'pie'; break;
                case 12: seriesType = 'area'; break;
                case 13: seriesType = 'area', stacking = "normal"; break;
                case 14: seriesType = 'area'; stacking = "percent"; break;
                case WATERFALL_TYPE: seriesType = 'waterfall'; break;
            }

            var chartTitle = undefined;
            var xAxisObject = undefined;
            var yAxisObject = undefined;
            var tooltipObject = undefined;
            var legendObject = {
                enabled: true
            };

            if (data != null && data.seriesData != null && Array.isArray(data.seriesData)) {
                labels = Array.isArray(data.labels) ? data.labels : [];

                chartTitle = {
                    text: data.chartHeader ? data.chartHeader : null
                };

                if (layout == VERTICAL_COLUMN_RANGE_TYPE || layout == HORIZONTAL_COLUMN_RANGE_TYPE) {
                    var seriesCount = data.seriesData.length
                    if (seriesCount > 1) {
                        var firstSeriesData = data.seriesData[0].data ? data.seriesData[0].data : [];
                        var lastSeriesData = data.seriesData[seriesCount - 1].data ? data.seriesData[seriesCount - 1].data : [];

                        var dataToPlot = [];

                        for (var i = 0; i < labels.length; i++) {
                            dataToPlot.push([firstSeriesData[i], lastSeriesData[i]]);
                        }

                        series.push({
                            name: data.chartHeader ? data.chartHeader : null,
                            type: 'columnrange',
                            data: dataToPlot,
                            dataLabels: { enabled: showValues },
                        });

                        tooltipObject = {
                            useHTML: true,
                            pointFormatter: function () {
                                var low, high;
                                if (this.low < this.high) {
                                    low = this.low;
                                    high = this.high;
                                } else {
                                    low = this.high;
                                    high = this.low;
                                }

                                var tooltipText = '<span style="color:' + this.series.color + '">\u25CF</span><span>' + this.series.name + ': </span>';
                                tooltipText += '<strong>' + numberFormat(low, 2, null, false) + '</strong> - <strong>' + numberFormat(high, 2, null, false) + '</strong>';

                                if (!showChangesInTooltip) return tooltipText;

                                tooltipText += '<br/><br/>Changes : <br/>Not supported for selected layout';

                                return tooltipText;
                            }
                        };

                        xAxisObject = {
                            categories: labels
                        };

                        yAxisObject = {
                            title: {
                                text: yAxisName
                            }
                        };
                    } else {
                        emptyChart = true;
                        errorText = 'At least two series required';
                    }
                } else if (layout == PIE_TYPE) {
                    if (data.seriesData.length > 0) {
                        var seriesName = data.seriesData[0].name ? data.seriesData[0].name : "[No name]";
                        var seriesData = Array.isArray(data.seriesData[0].data) ? data.seriesData[0].data : [];

                        var pieSeriesData = [];
                        for (var i = 0; i < labels.length; i++) {
                            if (labels[i] !== undefined && seriesData[i] !== undefined) {
                                pieSeriesData.push({
                                    name: labels[i],
                                    y: seriesData[i]
                                });
                            }
                        }

                        series.push({
                            name: seriesName,
                            type: seriesType,
                            data: pieSeriesData
                        });

                        tooltipObject = {
                            pointFormat: 'Value: {point.y} ({point.percentage:.2f}%)'
                        };
                    } else {
                        emptyChart = true;
                        errorText = 'At least one chart required';
                    }
                } else if (layout == WATERFALL_TYPE) {
                    var seriesData = data.seriesData[0] && data.seriesData[0].data &&  Array.isArray(data.seriesData[0].data) ? data.seriesData[0].data : [];
                    if (seriesData.length > 0 && seriesData.length >= labels.length) {
                        series.push({
                            type: seriesType,
                            upColor: Highcharts.getOptions().colors[2],
                            color: Highcharts.getOptions().colors[3],
                            data: [],
                            dataLabels: { enabled: showValues },
                            pointPadding: 0
                        });

                        for (var i = 0; i < labels.length; i++) {
                            var waterfallDataPoint = {
                                name: labels[i]
                            };

                            if (seriesData[i] != null && seriesData[i] != undefined && !isNaN(seriesData[i])) {
                                waterfallDataPoint.y = seriesData[i];
                            } else {
                                waterfallDataPoint.color = Highcharts.getOptions().colors[1];
                                if (i === labels.length - 1) {
                                    waterfallDataPoint.isSum = true;
                                } else {
                                    waterfallDataPoint.isIntermediateSum = true;
                                }
                            }

                            series[0].data.push(waterfallDataPoint);
                        }

                        xAxisObject = {
                            type: 'category',
                            title: {
                                text: xAxisName
                            }
                        };

                        yAxisObject = {
                            title: {
                                text: yAxisName
                            },
                            labels: {
                                formatter: function () {
                                    return numberFormat(this.value, 2, null, false);
                                }
                            }
                        };

                        tooltipObject = {
                            pointFormat: '<b>{point.y:,.2f}</b>'
                        };

                        legendObject.enabled = false;
                    } else {
                        emptyChart = true;
                        errorText = 'At least one series required';
                    }
                } else {
                    if (data.seriesData.length > 0) {
                        var hasMoreYAxes = false;
                        for (var i = 0; i < data.seriesData.length; i++) {
                            var axisToUse = data.seriesData[i].axisToUse ? data.seriesData[i].axisToUse : 0;
                            var seriesName = data.seriesData[i].name ? data.seriesData[i].name : "[No name]";
                            var seriesData = Array.isArray(data.seriesData[i].data) ? data.seriesData[i].data : [];
                            var seriesColor = Highcharts.Color(getColor(i)).setOpacity(0.7).get('rgba');

                            if (axisToUse > 0) hasMoreYAxes = true;

                            series.push({
                                yAxis: axisToUse,
                                name: seriesName,
                                data: seriesData,
                                type: seriesType,
                                dashStyle: dashedLine ? "Dash" : "Solid",
                                color: seriesColor,
                                dataLabels: {
                                    enabled: showValues
                                },
                            });
                        }

                        xAxisObject = {
                            categories: labels,
                            title: {
                                text: xAxisName
                            }
                        };

                        yAxisObject = [{
                            title: {
                                text: yAxisName
                            },
                            labels: {
                                formatter: function () {
                                    return numberFormat(this.value, 2, null, false);
                                }
                            }
                        }];

                        if (hasMoreYAxes) {
                            yAxisObject.push({
                                labels: {
                                    formatter: function () {
                                        return numberFormat(this.value, 2, null, false);
                                    }
                                },
                                opposite: true
                            });
                        }

                        tooltipObject = {
                            crosshairs: true,
                            shared: true,
                            useHTML: true,
                            formatter: function () {
                                var xIndex = this.points && this.points[0] && this.points[0].point && this.points[0].point.x !== null && this.points[0].point.x !== undefined ? this.points[0].point.x : null;
                                if (xIndex === null) return null;
                                var s = this.x;

                                $.each(this.points, function (i, point) {
                                    s += '<br/><span style="color:' + point.series.color + '">\u25CF</span><span>' + point.series.name + ': </span>';
                                    s += numberFormat(point.y, 2, null, false);
                                });

                                if (xIndex === 0 || !showChangesInTooltip) return s;

                                s += '<br/><br/>Changes:';

                                $.each(this.points, function (i, point) {
                                    if (point && point.point && point.point.index == 0) return;

                                    s += '<br/><span style="color:' + point.series.color + '">\u25CF</span><span>' + point.series.name + ': </span>';

                                    var pointIndex = point.point.index;
                                    var currentValue = point.y;
                                    var prevValue = point && point.series && point.series.data && point.series.data[pointIndex - 1] ? point.series.data[pointIndex - 1].y : 0;
                                    var diff = currentValue - prevValue;
                                    var percentageDiff = ((currentValue / prevValue) - 1) * 100;
                                    if (isNaN(percentageDiff) || percentageDiff == Infinity || percentageDiff == -Infinity) percentageDiff = 0;

                                    s += numberFormat(diff, 2, null, false) + '  :  ' + numberFormat(percentageDiff, 2, null, false) + '%';
                                });

                                return s;
                            }
                        };
                    } else {
                        emptyChart = true;
                        errorText = 'At least one series required';
                    }
                }                
            } else {
                emptyChart = true;
            }

            var chartData = {
                series: series,
                chart: {
                    inverted: inverted,
                    events: {
                        load: function () {
                            if (emptyChart) {
                                this.renderer.text(errorText, 40, 70)
                                    .css({
                                        color: '#1010114d',
                                        fontSize: '24px'
                                    })
                                    .add();
                            }
                        }
                    }
                },
                xAxis: xAxisObject,
                yAxis: yAxisObject,
                plotOptions: {
                    bar: {
                        stacking: stacking
                    },
                    column: {
                        groupPadding: 0,
                        softThreshold: false,
                        shadow: true,
                        pointPadding: 0.05,
                        borderWidth: 0,
                        stacking: stacking
                    },
                    area: {
                        stacking: stacking
                    },
                    pie: {
                        dataLabels: {
                            enabled: showValues,
                            useHTML: true,
                            format: '<b>{point.name}</b>: {point.y} ({point.percentage:.2f}%)'
                        }
                    },
                    line: {
                        marker: {
                            enabled: showLineMarkers
                        },
                        dataLabels: {
                            enabled: showValues
                        }
                    }
                },
                tooltip: tooltipObject,
                legend: legendObject,
                title: chartTitle
            };

            destroyChart(chartDiv, function (chartObj) { chartObj = new Highcharts.Chart($.extend(true, baseVariables, chartData)); });
        },
        ganttChart: function (data) {

            var fixDate = function (date) {
                date.setUTCHours(0);
                date.setUTCMinutes(0);
                date.setUTCSeconds(0);
                date.setUTCMilliseconds(0);
                return date.getTime();
            }

            var seriesData = [];
            if (data && Array.isArray(data.AllProjectDetails)) {
                var maxCost, minCost;
                if (data.AllProjectDetails[0]) {
                    maxCost = data.AllProjectDetails[0].cost;
                    minCost = data.AllProjectDetails[0].cost;
                }

                for (var i = 1; i < data.AllProjectDetails.length; i++) {
                    var subproject = data.AllProjectDetails[i];
                    
                    if (subproject.cost < minCost) minCost = subproject.cost;
                    if (subproject.cost > maxCost) maxCost = subproject.cost;
                }

                var MIN_WIDTH = 5;
                var MAX_WIDTH = 30;

                var fnK = (MAX_WIDTH - MIN_WIDTH) / (maxCost - minCost);
                var fnN = MIN_WIDTH - (fnK * minCost);

                if (isNaN(fnK) || fnK === Infinity || fnK === -Infinity) fnK = 0;
                if (isNaN(fnN) || fnN === Infinity || fnN === -Infinity) fnN = 0;

                var seriesWidthFn = function (cost) {
                    var result = fnK * Math.abs(cost) + fnN;

                    if (result < MIN_WIDTH) return MIN_WIDTH;
                    if (result > MAX_WIDTH) return MAX_WIDTH;

                    return result;
                }


                for (var i = 0; i < data.AllProjectDetails.length; i++) {
                    var subproject = data.AllProjectDetails[i];
                    var start = fixDate(new Date(subproject.start));
                    var end = fixDate(new Date(subproject.end));

                    seriesData.push({
                        name: subproject.name,
                        pointWidth: seriesWidthFn(subproject.cost),
                        showCheckbox: true,
                        start,
                        end,
                        custom: {
                            cost: subproject.cost
                        }
                    });

                }
            }

            var chartData = {
                chart: {
                    height
                },
                legend: {
                    enabled: false
                },
                series: [{
                    name: null,
                    data: seriesData
                }],
                xAxis: {
                    currentDateIndicator: true
                },
                tooltip: {
                    pointFormatter: function () {
                        var point = this,
                            format = '%e. %b',
                            cost = point.custom && point.custom.cost ? point.custom.cost : 0,
                            lines;

                        lines = [{
                            value: point.name,
                            style: 'font-weight: bold;'
                        }, {
                            title: 'Start',
                            value: Highcharts.dateFormat(format, point.start)
                        }, {
                            title: 'End',
                            value: Highcharts.dateFormat(format, point.end)
                        }, {
                            title: 'Cost',
                            value: cost
                            }
                        ];

                        var defined = Highcharts.defined;

                        return lines.reduce(function (str, line) {
                            var s = '',
                                style = (
                                    defined(line.style) ? line.style : 'font-size: 0.9em;'
                                );
                            if (line.visible !== false) {
                                s = (
                                    '<span style="' + style + '">' +
                                    (defined(line.title) ? line.title + ': ' : '') +
                                    (defined(line.value) ? line.value : '') +
                                    '</span><br/>'
                                );
                            }
                            return str + s;
                        }, '');
                    }
                },
                exporting: chartExportingOptions
            };



            destroyChart(chartDiv, function (chartObj) {
                chartObj = new Highcharts.ganttChart(chartDiv, chartData);
            });
        },
        empty: function () {
            destroyChart(chartDiv, function (chartObj) {
                chartObj = new Highcharts.Chart(baseVariables);
            });
        },
        showLoading: function () {
            var index=$('#' + chartDiv).attr('data-highcharts-chart');
            var chart=Highcharts.charts[index];

            if (chart === null || typeof (chart) === 'undefined') {
                chart = new Highcharts.Chart(baseVariables);
            }

            chart.showLoading();
        },
        hideLoading: function () {
            var index=$('#' + chartDiv).attr('data-highcharts-chart');
            var chart=Highcharts.charts[index];

            if (chart != null && typeof (chart) !== 'undefined') {
                chart.hideLoading();
            }
        }
    };
}

    function clone(item) {
        if (!item) { return item; } // null, undefined values check

        var types = [Number, String, Boolean],
            result;

        // normalizing primitives if someone did new String('aaa'), or new Number('444');
        types.forEach(function (type) {
            if (item instanceof type) {
                result = type(item);
            }
        });

        if (typeof result == "undefined") {
            if (Object.prototype.toString.call(item) === "[object Array]") {
                result = [];
                item.forEach(function (child, index, array) {
                    result[index] = clone(child);
                });
            } else if (typeof item == "object") {
                // testing that this is DOM
                if (item.nodeType && typeof item.cloneNode == "function") {
                    var result = item.cloneNode(true);
                } else if (!item.prototype) { // check that this is a literal
                    if (item instanceof Date) {
                        result = new Date(item);
                    } else {
                        // it is an object literal
                        result = {};
                        for (var i in item) {
                            result[i] = clone(item[i]);
                        }
                    }
                } else {
                    // depending what you would like here,
                    // just keep the reference, or create new object
                    if (false && item.constructor) {
                        // would not advice to do that, reason? Read below
                        result = new item.constructor();
                    } else {
                        result = item;
                    }
                }
            } else {
                result = item;
            }
        }

        return result;
    }

    var copy = clone({
        one: {
            'one-one': new String("hello"),
            'one-two': [
                "one", "two", true, "four"
            ]
        },
        two: document.createElement("div"),
        three: [
            {
                name: "three-one",
                number: new Number("100"),
                obj: new function () {
                    this.name = "Object test";
                }
            }
        ]
    })

    function destroyChart(elem, callback) {
        var index=$('#' + elem).attr('data-highcharts-chart');
        var chart=Highcharts.charts[index];

        if (chart != null && typeof (chart) !== 'undefined') {
            //chart.events = null;
            //chart.plotOptions.series.events = null;
            chart.destroy();
        }

        if (typeof (callback) === 'function') {
            callback(chart);
        }
    }



    
export function UpdateCorporateChart(callback) {
    
    // Some explanation about how the code for updating charts is working:
    // From changing DDLS's on the top-left Analysis output the 'export function UpdateCorporateChart' in 'chart.js'is called
    // And within the UpdateCorporateChart we then call 1) getCorporateChartFunc, and then 2) GetJsPageGraph

    // After 'export function UpdateCorporateChart' code then CorporateGraphs.cs is called, and then the code 'export function UpdateCorporateChart' in 'chart.js' is called :)
            
    
    // export function UpdateCorporateChart: is called when the user make chart choices (from e.g. functions.js)...called before the above 'export function getCorporateChartFunc' code..
    // ...After 'export function UpdateCorporateChart' code then CoprorateGraphs.cs is called, and then the above code 'export function UpdateCorporateChart' is called :)
    // PS! It is not made any previous checks if the user has selected relevant output
    // PS! Check if calc is made/outputArray exists...if does not exists then does not show the other ddl's
   
    var ChosengraphType = $("#ddl_PageGraph").val();
    if (ChosengraphType > 0) {
        $("#corporate-MainStatements").hide();
        $("#corporate-graph").show();
    }
    else {
        $("#corporate-MainStatements").hide();
        $("#corporate-graph").hide();
        if (typeof (callback) === 'function') {
            callback();
        }
        return;
    }

    $.ajax({
        url: Router.action("Portfolio", "CheckIfOutputArray", { area: "Corp" }),
        method: "GET",
        data: { CompanyId: GetCompanyId(), EntityId: GetEntityId() },
        statusCode: {
            200: function (data) {
                var OutputArrayExists = parseInt(data.JSonReturnValue);
                var nFX = parseInt(data.JSonReturnValuenFX);
                
                var nEntities = parseInt(data.JSonReturnValuenEntities);                

                var nSim = parseInt(data.JSonReturnValuenSim);

                var ModelVersion = parseInt(data.ModelVersion);
                var SimplifiedAdvancedInput= parseInt(data.SimplifiedAdvancedInput);

                var nCalc = parseInt(data.nCalc);
                if(nCalc == null){
                    nCalc == 1;
                }


                var MaxNumPeriods = $("#Index_MaxnPeriod").val();                       // only used to give user a correct msg wrt include Monte carlo
                if (MaxNumPeriods == null || MaxNumPeriods == 0) MaxNumPeriods = 12;

                var CorporateAccessViewType = parseInt($("#Index_CorporateAccessViewType").val());   
                if (CorporateAccessViewType == null) {
                    CorporateAccessViewType = 0;
                }
                if (isNaN(CorporateAccessViewType)) {
                    CorporateAccessViewType = 0;
                }

                if (isNaN(OutputArrayExists)) {
                    OutputArrayExists = 0;
                }
                if (isNaN(nFX)) {
                    nFX = 0;
                }
                if (isNaN(nEntities)) {
                    nEntities = 0;
                }
                if (isNaN(nSim)) {
                    nSim = 0;
                }

                if(nEntities<2){                       
                    $("#corporate-output-front .PageEntity1 select").prop("selectedIndex", 1);  // If only 1 Entity then auto-select  it 
                }

                if (OutputArrayExists > 0) {

                    // Alt a) Read from HTML
                    ////var Tall0 = parseInt($("#corporate-output-front .PageGraph").val());
                    //var Tall0 = parseInt($("#corporate-output-front #ddl_PageGraph").val());

                    //var Tall1 = parseInt($("#corporate-output-front .PageEntity1 select").val());
                    //var Tall2 = parseInt($("#corporate-output-front .PageEntity2 select").val());
                    //var Tall3 = parseInt($("#corporate-output-front .PageVariable1 select").val());
                    //var Tall4 = parseInt($("#corporate-output-front .PageVariable2 select").val());
                    var Tall5 = parseInt($("#corporate-output-front .PageVariable1Sim select").val());
                    var Tall6 = parseInt($("#corporate-output-front .PageVariable2Sim select").val());
                    var Tall7 = parseInt($("#corporate-output-front .PageDistributionEndPeriod select").val());
                    var Tall8 = parseInt($("#corporate-output-front .PageLayout select").val());
                    
                    // Do we need the 2 below
                    //var Tal9 = parseInt($("#corporate-output-front .PageCalculation1 select").val());
                    //var Tal10 = parseInt($("#corporate-output-front .PageCalculation2 select").val());


                    // Alt B) Read from saved values?     ..... then include reading the saved graph settings on the CheckIfOutputArray? ....NB! Use this alt. B) if put checks also in the backedn/cs code
                    // ...PS! The saved chart settings data are used in the backend to populate DDLs with correct alternatives/variables
                    var Tall0 = parseInt(data.Company_Output_PageGraph);

                    var Tall1 = parseInt(data.Company_Output_PageEntity1);
                    var Tall2 = parseInt(data.Company_Output_PageEntity2);

                    var Tall3 = parseInt(data.Company_Output_PageVariable1);
                    var Tall4 = parseInt(data.Company_Output_PageVariable2);





                    var nFXMax = parseInt($("#Index_nFXMax").val());

                    if (isNaN(Tall0)) { Tall0 = 0; }
                    if (isNaN(Tall1)) { Tall1 = 0; }
                    if (isNaN(Tall2)) { Tall2 = 0; }
                    if (isNaN(Tall3)) { Tall3 = 0; }
                    if (isNaN(Tall4)) { Tall4 = 0; }
                    if (isNaN(Tall5)) { Tall5 = 0; }
                    if (isNaN(Tall6)) { Tall6 = 0; }
                    if (isNaN(Tall7)) { Tall7 = 0; }
                    if (isNaN(Tall8)) { Tall8 = 0; }
                    if (isNaN(nFXMax)) { nFXMax = 1; }


                    // ### Set values based on avaliable output
                    // .. Different calculations can have different number of entities inlcuded..the below 'nEntities' is the number of entities included in the current calculation
                    //alert(nEntities)
                    //alert(Tall1)
                    if (nEntities < 2){     
                        //alert("if(nEntities<2)" +nEntities)
                        Tall1 =1;  // If only 1 Entity then auto-select it ...in the CorporateGraph
                    }

                    // If Dev chart 
                    if (Tall0 == 2 && Tall1 > (nEntities + 2) ) {
                        Tall1 = 1; 
                    }
                    // If other charts... then do not have the Entity choice: 'All' .... Update this code if creates other charts where can show all entities at the same time
                    if (Tall0 != 2 && Tall1 > (nEntities + 1)) {
                        Tall1 = 1;
                    }

                    if (Tall2 > (nEntities + 1)) {
                        Tall2 = 1;
                    }


                    // ### Set/check values based on different chart and nEntities and nCalc     ---- BACK-UP CHECK...SHOULD NOT BE NEEDED...
                    if(Tall0 == 5 && nCalc<2 && nEntities<2){
                        Tall2 = 0;      // Then do not include the 2'nd output on the Val chart...as it will be the same as the first
                    }



                    // ######  TAILOR MADE CHART: CONVERT TO GENERIC TYPES ######
                    if(Tall0 == 101){
                        Tall0 = 4;          // Convert to Generic Distribution chart
                        Tall3 = 65;         // 65 is Valuation
                        Tall7 =1;           // Period
                        Tall2 = 0;         // Valuation range ...no Entity 2
                    }

                    

                    // Add check if selected relevant ddl's to show a relevant chart...NB! Must check for the different chart types as needs separate selected variables
                    var TestIfShowChart = 0;
                    if (Tall0 == 1) {
                        TestIfShowChart = 1;        // Statements...must have chosen (Entity1 & variable1) or (Entity2 & variable2)..the only chart that can show all entities
                    }
                    if (Tall0 == 2) {
                        if (Tall1 > 0 && Tall3 > 0 || Tall2 > 0 && Tall4 > 0) {
                            TestIfShowChart = 1;        // Develpment chart...must have chosen (Entity1 & variable1) or (Entity2 & variable2)..the only chart that can show all entities
                        }
                    }
                    if (Tall0 == 3) {
                        if (Tall1 > 0 && Tall3 > 0 && Tall3 != 65 && nSim > 1 && Tall1 <= (nEntities + 1)) {                            
                            TestIfShowChart = 1;        // Fan chart...not available for Valuation as valuation is an estimated value at this point, not going forward in time....
                        }
                    }
                    if (Tall0 == 4) {
                        if (Tall1 > 0 && Tall3 > 0 && Tall1 <= (nEntities + 1) && nSim > 1 && (Tall3 != 301 || Tall3 != 302 || Tall3 != 303 || Tall3 != 304 )) {
                            TestIfShowChart = 1;        // Distribution chart & 'Flying Bar chart'..... PS! Do not have the data for MC variables changes 
                        }
                    }
                    if (Tall0 == 5) {
                        if (Tall1 > 0 && Tall1 <= (nEntities + 1) || Tall2 > 0 && Tall2 <= (nEntities+1)) {
                            TestIfShowChart = 1;        // Valuation chart
                        }
                    }
                    if (Tall0 == 6) {
                        if (nEntities > 1) {
                            TestIfShowChart = 1;        // Valuation per entity ...PS! Bigger than 2 as Consolidated is also included in the nEntities nr from the controller
                        }
                        else {
                            messageDialog("Valuation", "Valuation per entity is only available if more than 1 entity is included in the company. ", 200, 300);
                        }
                    }

                    // if (Tall0 == 7 && nFXMax > 1)
                    if (Tall0 == 7 && Tall1 <= (nEntities+1)) {
                        if(nFX > 1){
                            if (Tall1 > 0 && Tall3 > 0) {
                                if (Tall3 < 19 || Tall3 == 57 || Tall3 == 22) {
                                    TestIfShowChart = 1;        // Currency exposure
                                }
                                else {
                                    messageDialog("Currency exposure", "Currency exposure is available for Income Statement items, Cash Flow items , Balance Sheet items, and Loan amounts. ", 200, 200);
                                }
                            }
                        }
                        else{
                            messageDialog("Currency exposure", "Please add currencies on the Currency setup tab. Currency exposure is available for Income Statement items, Cash Flow items , Balance Sheet items, and Loan amounts. ", 200, 200);
                        } 
                    }

                    // Waterfall:
                    // New logic: Do not prevent the User from output other variables as Waterfall chart, even if the User selects something that should not make sense outputting as Waterfall
                    // LATER? Implement a thorough check wrt which variables should be possible to output as Waterfall ? ? ?

                    // if (Tall0 == 8 && nEntities > 1 && Tall3 < 22) {
                    if (Tall0 == 8 && nEntities > 1) {
                        // if (Tall3 > 0 && Tall3 < 55)
                        if (Tall3 > 0) {
                            TestIfShowChart = 1;
                        }
                    }

                    // Football field valuation (show if entity1 is selected)
                    if (Tall0 == 9 && Tall1 > 0) {
                        TestIfShowChart = 1;
                    }
                                        


                    // ### Check based on Consolidated
                    // BETTER IDEA? Check where save the output choice settings, then will be correct in all following places?
                    // Idea: Have the below (and corresponding checks) inside the 'public JsonResult CheckIfOutputArray' ?
                    // Check for Consolidated Output --- If not chosen relevant output, then set the output to something relevant
                    // ... the code in CorporateVariables.cs shall show the relevant output ddls, but the User may accidentally first have selected an outputvariable and then select from an Entity to Consolidated                   
                    if (nEntities > 1 && Tall1 == 1 && (Tall3 == 62 || Tall3 == 63 || Tall3 == 64 || Tall3 == 302 || Tall3 == 303 || Tall3 == 304)) {
                        TestIfShowChart = 0;    // Do NOT Show chart...if chosen Consolidated and Price, COGS or Fixed costs
                    }






                    // ### Set/check values based on different Model versions

                    // Equity Analysis Model
                    if (CorporateAccessViewType == 4) {                                                

                        if (Tall0 == 4) {
                            Tall3 = 65;         // If Distribution chart (4), only Valuation range output (65)
                        }                        
                    }

                    
                    // Check if Commodity Exposure Model...... NB! Also a check about 200 lines below
                    if(CorporateAccessViewType == 1){                                         
                        // ... due to has possibility to include several products but they are automatically selected to be oprationally included in the first entity, there IS, CF, BS output from these other products are not relevant
                        // Cannot show Price, Variable Costs, Fixed costs per entity, if more than 1 entity and selected the Company..PS! Check 'nEntities>2' as consolidated is added to the 1 entity... 
                        if(nEntities>1 && Tall1 == 1 && (Tall3 == 62 || Tall3 == 63 || Tall3 == 64)){
                            TestIfShowChart = 0;    // Do NOT Show chart
                        }
                        if(nEntities>1 && Tall0 == 2 && Tall2 == 1 && (Tall4 == 62 || Tall4 == 63 || Tall4 == 64)){
                            TestIfShowChart = 0;    // Do NOT Show chart
                        }

                    }



                    if (Tall0 >= 10000 && Tall0 < 11000) {
                        TestIfShowChart = 1;
                    }
                    if (Tall0 >= 30000 && Tall0 < 40000) {
                        TestIfShowChart = 1;
                    }
                    if (Tall0 == 40000) {
                        TestIfShowChart = 1;
                    }

                    if (TestIfShowChart == 1) {
                        var clickCallback = function (chartData) {
                            // Set bigger chart height according to windows viewport (hard otherwise because of modal)
                            var bigGraphName = 'corporate-graph-big';

                            chartData.chart.height = $(window).height() - 200;
                            chartData.chart.renderTo = bigGraphName;

                            var dialog = bootbox.dialog({
                                title: "",
                                className: "fullscreen-modal",
                                message: $('<div id="' + bigGraphName + '" style="width: 100%;" />'),
                                show: false,
                                buttons: {
                                    Close: {
                                        label: "Close",
                                        className: "btn-default",
                                        callback: function () {
                                        }
                                    }
                                }
                            });

                            (function(callback) {
                                var index=$('#' + bigGraphName).attr('data-highcharts-chart');
                                var chart=Highcharts.charts[index];

                                if (chart === null || typeof (chart) === 'undefined') {
                                    chart = new Highcharts.Chart(chartData);
                                }
                                callback();
                            })(function() {
                                dialog.modal('show');
                            });
                        }

                        var ChartHeight_Set = 350;  // Default
                        var ChartWidth_Set = 700;   // Default

                        if (data.ChartHeight != null){
                            ChartHeight_Set = parseInt(data.ChartHeight);
                            
                        }
                        if (data.ChartWidth != null){
                            ChartWidth_Set = parseInt(data.ChartWidth);
                        }

                        
                        var ChartHeight = ChartHeight_Set;          // Default Chart height
                        var ChartWidth = ChartWidth_Set;
                        var NrIndex_TabView = parseInt($("#ddl_TabView").val());
                        if (NrIndex_TabView == null) {
                            NrIndex_TabView = 0;
                        }
                        if (isNaN(NrIndex_TabView)) {
                            NrIndex_TabView = 0;
                        }     
                        if(NrIndex_TabView == 5 || NrIndex_TabView == 11){
                            ChartHeight = 700;
                            ChartWidth = 900;
                        }

                        var charts = getCorporateChartFunc('corporate-graph', clickCallback, null, ChartHeight, ChartWidth);

                        charts.showLoading();
                        var Calculation1Nr = parseInt(data.Company_Output_Calculation1);
                        var Calculation2Nr = parseInt(data.Company_Output_Calculation2);

                        if (isNaN(Calculation1Nr)) Calculation1Nr = 0;
                        if (isNaN(Calculation2Nr)) Calculation2Nr = 0;
                        var Analysis2 = $("#ddl_Analysis2").val();

                        $.ajax({
                            url: Router.action("Portfolio", "GetJsPageGraph", { area: "Corp", CompanyId: GetCompanyId(), EntityId: GetEntityId()}),
                            method: "POST",
                            contentType: 'application/json; charset=UTF-8',
                            data: JSON.stringify({
                                ChartType: Tall0,
                                First: {
                                    Entity: Tall1,
                                    Output: Tall3,
                                    BaseSim: Tall5,
                                    CalculationNr: Calculation1Nr
                                },
                                Second: {
                                    Analysis: Analysis2,
                                    Entity: Tall2,
                                    Output: Tall4,
                                    BaseSim: Tall6,
                                    CalculationNr: Calculation2Nr
                                },
                                DistributionEndPeriod: Tall7,
                                Layout: Tall8
                            }),
                            success: function (data) {
                                var htmlDecode = function (input) {
                                    var e = document.createElement('div');
                                    e.innerHTML = input;
                                    return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
                                }

                                if (Tall0 >= 10000 && Tall0 < 11000) {
                                    Tall0 = 10;
                                } else if (Tall0 >= 30000 && Tall0 < 40000) {
                                    Tall0 = 10;
                                } else if (Tall0 == 40000) {
                                    Tall0 = 11;
                                }

                                switch (Tall0) {
                                    case 1: charts.statements(data); break;
                                    case 2:
                                        var useSecondYAxis = $("#useSecondYAxis").is(":checked");
                                        data['useSecondYAxis'] = useSecondYAxis;
                                        charts.development(data, Tall8);
                                        break;
                                    case 3: charts.riskFan(data); break;
                                    case 4: charts.distribution(data, Tall8); break;
                                    case 5: charts.valuation(data); break;
                                    case 6: charts.valPerEntity(data); break;
                                    case 7: if (Tall8 == 0 || Tall8 == 1) {
                                        charts.fxExposureDev(data, Tall8); break;
                                    } else if (Tall8 == 2 || Tall8 == 3) {
                                        charts.fxExposureVar(data, Tall8); break;
                                    }
                                    case 8: charts.waterfall(data, Tall8); break;
                                    case 9: charts.footballFieldValuation(data); break;
                                    case 10:
                                        var showValues = $("#showValuesOnChart").is(":checked");
                                        var showChangesInTooltip = $("#showChangesInTooltip").is(":checked");
                                        data['showValues'] = showValues;
                                        data['showChangesInTooltip'] = showChangesInTooltip;
                                        charts.customUserDataDevelopment(data, Tall8);
                                        break;
                                    case 11: charts.ganttChart(data); break;
                                    default: charts.empty(); break;
                                }
                            },

                            error: function (data) {
                                getCorporateChartFunc('corporate-graph').empty();
                            },

                            complete: function () {
                                // NB! WE ARE CURRENTLY NOT SHOWING THE HELP TEXT GENERATED ON Index.CSHTML, SO THE CODE IS NOT NECESSARY TO BE CALLED
                                //$.ajax({
                                //    // PS! We are currently not showing lbl_PageHelpText and lbl_PageHelpText on the Index.cshtml
                                //    // ...can/should we thus remove this?

                                //    url: Router.action("Portfolio", "lbl_PageHelpText", { area: "Corp" }),
                                //    data: { pageGraph: Tall0, pageEntity1: Tall1, pageVariable1: Tall3, pageVariable1Sim: Tall5, pageEntity2: Tall2, pageVariable2: Tall4, pageVariable2Sim: Tall6, CompanyId: GetCompanyId(), EntityId: GetEntityId() },
                                //    success: function (data) {
                                //        $("#lbl_PageHelpText").html(data.JSonReturnString1);
                                //        $("#lbl_PageHelpText2").html(data.JSonReturnString2);
                                //    },
                                //    complete: function () {
                                //        charts.hideLoading();
                                //        if (typeof (callback) == "function") {
                                //            callback();
                                //            //setTimeout(function () { callback() }, 0);
                                //        }
                                //    }
                                //});
                            }
                        });
                    } else {

                        // Possible give feedback that No Risk is included
                        if (Tall0 == 3) {
                            if (Tall1 > 0 && Tall3 > 0 && Tall3 != 65 && nSim <= 1) {
                                // NB! Include another message if Free Version!
                                if (MaxNumPeriods <= 12) {
                                    messageDialog("Fan chart ", "Input Std.dev. and Calculate in order to generate this output. ", null, null);
                                }
                                else {
                                    messageDialog("Fan chart ", "Input Std.dev. and Calculate in order to generate this output. ", null, null);
                                }
                            }
                        }
                        if (Tall0 == 4) {
                            if (Tall1 > 0 && Tall3 > 0 && nSim <= 1) {
                                if (MaxNumPeriods <= 12) {
                                    messageDialog("Distribution chart", "Input Std.dev. and Calculate in order to generate this output.  ", null, null);
                                }
                                else {
                                    messageDialog("Distribution chart ", "Input Std.dev. and Calculate in order to generate this output.  ", null, null);
                                }
                            }
                        }

                        // Possible give feedback if chosen All Entities, and it is not relevant for this particular chart...
                        if (Tall0 == 3 || Tall0 == 4 || Tall0 == 7) {
                            if (Tall1 > (nEntities + 1)) {
                                // messageDialog("All Entities", "All Entities are only possible for Development chart & Bar chart", 200, 300);
                                $("#corporate-output-front .PageEntity1 select").prop("selectedIndex", 0);
                            }
                        }

                        // Waterfall:
                        if (Tall0 == 8) {
                            if (nEntities < 2) {
                                messageDialog("Waterfall chart ", "Waterfall chart is only available if more than 1 entities.", null, null);
                            }
                            // New logic: Do not prevent the User from output other variables as Waterfall chart, even if the User selects something that should not make sense outputting as Waterfall
                            // LATER? Implement a thorough check wrt which variables should be possible to output as Waterfall ? ? ?
                            // also CorporateGraphs.cs - if (AdjnEntities > 1 && chart.First.Output < 22)
                            //else {
                            //    if (Tall3 > 21) {
                            //        messageDialog("Waterfall chart ", "Waterfall chart is available for Income statement, Cash flow, Balance sheet variables and Key ratios: EPS and CEPS. ", null, null);
                            //    }
                            //}
                        }

                        // #####  Commodity Exposure Model ##### and not chosen relevant output... NB! Also a check about 200 lines above
                        if(CorporateAccessViewType == 1){ 
                            // NB! COMMENTED BELOW CODE AS CHANGE LOGIC TO SHOW ALL FOR ALL PRODUCTS/ENTITIES
                            
                            ////  ..... PS! Tall1 = Entity 1...and Tall2 = Entity 2
                            //if(Tall1>1 && Tall3>0){     
                            //    // For the first Entity If selected Product 2+ and the first selected output is not relevant 
                            //    if(Tall3 == 1 || Tall3 == 2 || Tall3 == 5 || Tall3 == 23 || Tall3 == 24 || Tall3 == 28 || Tall3 == 29 || Tall3 == 46 || Tall3 == 56 || Tall3 == 57 || Tall3 == 58 || Tall3 == 65 || Tall3 == 66 || Tall3 == 67 || Tall3 == 68 || Tall3 == 71 ){
                            //        // Show chart                                    
                            //    }
                            //    else{                                    
                            //        messageDialog("Not relevant output ", "This output is not available for products.", null, null);
                            //    }                            
                            //}
                            //// b) Dev chart: If the second selected entity has selected Product 2+
                            //if(Tall0 == 2 && Tall2>1 && Tall4>0){    
                            //    if(Tall4 == 1 || Tall4 == 2 || Tall4 == 5 || Tall4 == 23 || Tall4 == 24 || Tall4 == 28 || Tall4 == 29 || Tall4 == 46 || Tall4 == 56 || Tall4 == 57 || Tall4 == 58 || Tall4 == 65 || Tall4 == 66 || Tall4 == 67 || Tall4 == 68 || Tall4 == 71 ){
                            //        // Show chart                                    
                            //    }
                            //    else{
                            //        messageDialog("Not relevant output ", "This output is not available for products.", null, null);
                            //    }                                              
                            //}
                            // Cannot show Price, Variable Costs, Fixed costs per entity, if more than 1 entity and selected the Company
                            if(nEntities>2 && Tall1 == 1 && (Tall3 == 62 || Tall3 == 63 || Tall3 == 64)){
                                TestIfShowChart = 0;    // Do NOT Show chart
                                messageDialog("Not relevant output ", "Cannot show this output for the Company as may be different Products.", null, null);
                            }
                            if(nEntities>2 && Tall0 == 2 && Tall2 == 1 && (Tall4 == 62 || Tall4 == 63 || Tall4 == 64)){
                                TestIfShowChart = 0;    // Do NOT Show chart
                                messageDialog("Not relevant output ", "Cannot show this output for the Company as may be different Products.", null, null);
                            
                            }

                        }
                                               

                        // Same code as below if OutputArray does not exist...except messageDialog
                        //messageDialog("Calculation", "A calculation must be done before an analysis can be chosen", null, null);
                        //$("#corporate-output-front .PageGraph").prop("selectedIndex", 0);                    
                        //$("#corporate-output-front .PageGraph select").prop("selectedIndex", 0);        // 2014 10 30

                        // Below: Hide all
                        $("#corporate-graph").hide();
                        //$("#corporate-output-front .lbl_PageVariable1").hide();
                        //$("#corporate-output-front .PageEntity1").hide();
                        //$("#corporate-output-front .PageVariable1").hide();
                        //$("#corporate-output-front .PageVariable1Sim").hide();
                        //$("#corporate-output-front .lbl_PageVariable2").hide();
                        //$("#corporate-output-front .PageEntity2").hide();
                        //$("#corporate-output-front .PageVariable2").hide();
                        //$("#corporate-output-front .PageVariable2Sim").hide();
                        //$("#corporate-output-front .lbl_ChartBaseSim").hide();  
                        //$("#corporate-output-front .lbl_ChartLayout").hide();
                        //$("#corporate-output-front .PageLayout").hide();
                        //$("#corporate-output-front .lbl_EndPeriod").hide();
                        //$("#corporate-output-front .PageDistributionEndPeriod").hide();
                        if (typeof (callback) == "function") {
                            //setTimeout(function () { callback() }, 1000);
                            setTimeout(function () { callback() }, 100);
                        }


                    }
                }
                else {
                    // if (OutputArrayExists > 0)  ....if OutputArray does not exist!

                    // Frank - temporarily hide
                    //messageDialog("Calculation", "A calculation must be done before an analysis can be chosen", null, null);

                    //$("#corporate-output-front .PageGraph").prop("selectedIndex", 0);
                    //$("#corporate-output-front .PageGraph select").prop("selectedIndex", 0);        
                    $("#corporate-output-front #ddl_PageGraph").prop("selectedIndex", 0);

                    // Below: Hide all
                    $("#corporate-graph").hide();
                    $("#corporate-output-front .lbl_PageVariable1").hide();
                    $("#corporate-output-front .PageEntity1").hide();
                    $("#corporate-output-front .PageVariable1").hide();
                    $("#corporate-output-front .PageVariable1Sim").hide();
                    $("#corporate-output-front .PageCalculation1").hide();
                    $("#corporate-output-front .lbl_PageVariable2").hide();
                    $("#corporate-output-front .PageEntity2").hide();
                    $("#corporate-output-front .PageVariable2").hide();
                    $("#corporate-output-front .PageVariable2Sim").hide();
                    $("#corporate-output-front .PageCalculation2").hide();
                    $("#corporate-output-front .lbl_ChartBaseSim").hide();  
                    $("#corporate-output-front .lbl_ChartLayout").hide();
                    $("#corporate-output-front .PageLayout").hide();

                    //$("#corporate-output-front .lbl_EndPeriod").hide();
                    $("#corporate-output-front .PageDistributionEndPeriod").hide();

                    $("#corporate-output-front .lbl_ChartBaseSim").hide();

                    if (typeof (callback) == "function") {
                        //setTimeout(function () { callback() }, 1000);
                        setTimeout(function () { callback() }, 100);
                    }
                }
            }
        },
        complete: function (e, xhr, settings) {
            if (!(e.status === 200/* || e.status === 500*/)) {
                if (typeof (callback) == "function") {
                    //setTimeout(function () { callback() }, 1000);
                    setTimeout(function () { callback() }, 100);
                }
            }
        }
    });
}
